(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a10-2026-media-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-media-hero')) {
    customElements.define('ulike-media-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.update = () => {
          const allowed = this.visible && document.readyState === 'complete' && !document.hidden && !this.motion.matches && !navigator.connection?.saveData;
          if (!allowed) { this.video.pause(); return; }
          const source = this.video.querySelector('source[data-src]');
          if (source) { source.src = source.dataset.src; source.removeAttribute('data-src'); this.video.load(); }
          this.video.play().catch(() => {});
        };
        this.motion.addEventListener('change', this.update);
        window.addEventListener('load', this.update);
        document.addEventListener('visibilitychange', this.update);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
        if (!this.update) return;
        this.motion.removeEventListener('change', this.update);
        window.removeEventListener('load', this.update);
        document.removeEventListener('visibilitychange', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a10-2026-purchase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-subscription-purchase]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-product-form]');
      const variantInput = root.querySelector('[data-variant-id]');
      const sellingPlanInput = root.querySelector('[data-selling-plan]');
      const terms = root.querySelector('[data-subscription-terms]');
      const termsWrap = root.querySelector('[data-subscription-terms-wrap]');
      const error = root.querySelector('[data-form-error]');
      const buttonPrice = root.querySelector('[data-button-price]');
      const currentPrice = root.querySelector('[data-current-price]');
      const comparePrice = root.querySelector('[data-compare-price]');
      const oneTimePrice = root.querySelector('[data-one-time-price]');
      const refillPrice = root.querySelector('[data-refill-price]');
      const mediaPanels = [...root.querySelectorAll('[data-media-panel]')];
      const mediaButtons = [...root.querySelectorAll('[data-gallery-media]')];
      const thumbnailRail = root.querySelector('.subscription-purchase__thumbnails');
      const primaryMedia = root.querySelector('[data-primary-media]');
      const pairedProducts = root.dataset.purchaseMode === 'paired_products';
      const frequencyCopyNodes = [...root.querySelectorAll('[data-frequency-copy]')];
      const termsDialog = root.querySelector('[data-terms-dialog]');
      const termsFrame = root.querySelector('[data-terms-frame]');

      frequencyCopyNodes.forEach((node) => {
        node.dataset.frequencyTemplate = node.textContent.trim();
      });

      const updateFrequencyCopy = (planInput) => {
        const planLabel = planInput?.nextElementSibling?.textContent || planInput?.dataset.planName || '';
        const monthMatch = planLabel.match(/(\d+)\s*(?:mo(?:nth)?s?)/i);
        if (!monthMatch) return;
        const monthCount = Number(monthMatch[1]);
        const replacement = `every ${monthCount} ${monthCount === 1 ? 'month' : 'months'}`;
        frequencyCopyNodes.forEach((node) => {
          node.textContent = node.dataset.frequencyTemplate.replace(/every\s+\d+\s+months?/gi, replacement);
        });
      };

      const syncTermsState = (subscription) => {
        if (!terms) return;
        terms.required = subscription;
        terms.disabled = !subscription;
        if (!subscription) terms.checked = false;
        if (termsWrap) termsWrap.hidden = !subscription;
      };

      const selectMedia = (mediaId) => {
        if (!mediaId) return false;
        const panel = mediaPanels.find((item) => item.dataset.mediaPanel === String(mediaId));
        if (!panel) return false;
        mediaPanels.forEach((item) => {
          const active = item === panel;
          item.classList.toggle('is-active', active);
          item.hidden = !active;
          if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
        });
        mediaButtons.forEach((item) => {
          const active = item.dataset.galleryMedia === String(mediaId);
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active && window.matchMedia('(max-width: 989px)').matches) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
        return true;
      };

      if (thumbnailRail) {
        let dragStartX = 0;
        let dragStartY = 0;
        let dragScrollLeft = 0;
        let dragScrollTop = 0;
        let isDragging = false;
        let suppressClick = false;
        let activePointerId = null;

        thumbnailRail.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          activePointerId = event.pointerId;
          dragStartX = event.clientX;
          dragStartY = event.clientY;
          dragScrollLeft = thumbnailRail.scrollLeft;
          dragScrollTop = thumbnailRail.scrollTop;
          isDragging = false;
          suppressClick = false;
        });
        thumbnailRail.addEventListener('pointermove', (event) => {
          if (activePointerId !== event.pointerId) return;
          const deltaX = event.clientX - dragStartX;
          const deltaY = event.clientY - dragStartY;
          const mobileRail = window.matchMedia('(max-width: 989px)').matches;
          if (!isDragging && mobileRail && Math.abs(deltaY) > Math.abs(deltaX)) {
            activePointerId = null;
            return;
          }
          if (!isDragging && Math.hypot(deltaX, deltaY) < 5) return;
          if (!isDragging) {
            isDragging = true;
            thumbnailRail.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          if (mobileRail) thumbnailRail.scrollLeft = dragScrollLeft - deltaX;
          else thumbnailRail.scrollTop = dragScrollTop - deltaY;
        });
        thumbnailRail.addEventListener('pointerup', (event) => {
          if (activePointerId !== event.pointerId) return;
          suppressClick = isDragging;
          if (thumbnailRail.hasPointerCapture(event.pointerId)) thumbnailRail.releasePointerCapture(event.pointerId);
          isDragging = false;
          activePointerId = null;
        });
        thumbnailRail.addEventListener('pointercancel', () => {
          isDragging = false;
          activePointerId = null;
        });
        thumbnailRail.addEventListener('click', (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          suppressClick = false;
        }, true);
      }

      mediaButtons.forEach((button) => button.addEventListener('click', () => selectMedia(button.dataset.galleryMedia)));

      if (primaryMedia) {
        let mediaPointerId = null;
        let mediaStartX = 0;
        let mediaStartY = 0;
        let mediaDragging = false;
        let draggedPanel = null;

        const resetMediaDrag = () => {
          if (draggedPanel) {
            draggedPanel.style.transform = '';
            draggedPanel.style.transition = '';
          }
          draggedPanel = null;
          mediaDragging = false;
          mediaPointerId = null;
        };

        primaryMedia.addEventListener('pointerdown', (event) => {
          if (!window.matchMedia('(max-width: 989px)').matches || !event.isPrimary) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest('video, iframe, model-viewer, button')) return;
          mediaPointerId = event.pointerId;
          mediaStartX = event.clientX;
          mediaStartY = event.clientY;
          mediaDragging = false;
          draggedPanel = root.querySelector('[data-media-panel].is-active');
        });
        primaryMedia.addEventListener('pointermove', (event) => {
          if (mediaPointerId !== event.pointerId || !draggedPanel) return;
          const deltaX = event.clientX - mediaStartX;
          const deltaY = event.clientY - mediaStartY;
          if (!mediaDragging && Math.abs(deltaY) > Math.abs(deltaX)) {
            resetMediaDrag();
            return;
          }
          if (!mediaDragging && Math.abs(deltaX) < 6) return;
          if (!mediaDragging) {
            mediaDragging = true;
            primaryMedia.setPointerCapture(event.pointerId);
            draggedPanel.style.transition = 'none';
          }
          event.preventDefault();
          draggedPanel.style.transform = `translate3d(${deltaX}px, 0, 0)`;
        });
        primaryMedia.addEventListener('pointerup', (event) => {
          if (mediaPointerId !== event.pointerId) return;
          const deltaX = event.clientX - mediaStartX;
          const deltaY = event.clientY - mediaStartY;
          const currentIndex = mediaPanels.findIndex((panel) => panel.classList.contains('is-active'));
          const shouldChange = mediaDragging && Math.abs(deltaX) >= 45 && Math.abs(deltaX) > Math.abs(deltaY);
          const nextIndex = shouldChange
            ? Math.max(0, Math.min(mediaPanels.length - 1, currentIndex + (deltaX < 0 ? 1 : -1)))
            : currentIndex;
          if (primaryMedia.hasPointerCapture(event.pointerId)) primaryMedia.releasePointerCapture(event.pointerId);
          resetMediaDrag();
          if (nextIndex !== currentIndex) selectMedia(mediaPanels[nextIndex].dataset.mediaPanel);
        });
        primaryMedia.addEventListener('pointercancel', resetMediaDrag);
      }

      root.querySelector('[data-product-share]')?.addEventListener('click', async () => {
        const shareData = { title: root.dataset.productTitle, url: window.location.href };
        const status = root.querySelector('[data-share-status]');
        try {
          if (navigator.share) await navigator.share(shareData);
          else {
            await navigator.clipboard.writeText(shareData.url);
            if (status) status.textContent = 'Link copied';
          }
        } catch (error) {
          if (error?.name !== 'AbortError' && status) status.textContent = 'Copy the page URL to share';
        }
        if (status?.textContent) window.setTimeout(() => { status.textContent = ''; }, 2400);
      });

      const modelTrigger = root.querySelector('[data-model-trigger]');
      const modelOverlay = root.querySelector('[data-external-model]');
      const modelViewer = root.querySelector('[data-model-viewer]');
      modelTrigger?.addEventListener('click', () => {
        const modelUrl = modelTrigger.dataset.modelUrl;
        if (modelUrl && modelOverlay && modelViewer) {
          modelViewer.setAttribute('src', modelUrl);
          modelOverlay.hidden = false;
          return;
        }
        selectMedia(modelTrigger.dataset.nativeModelId);
      });
      root.querySelector('[data-model-close]')?.addEventListener('click', () => {
        if (modelOverlay) modelOverlay.hidden = true;
        if (modelViewer) modelViewer.removeAttribute('src');
      });

      root.querySelectorAll('[data-variant-option]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-variant-option]').forEach((item) => {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          variantInput.value = button.dataset.variantId;
          const subscriptionSelected = root.querySelector('[data-purchase-option]:checked')?.value === 'subscription';
          if (currentPrice) currentPrice.textContent = button.dataset.variantPrice;
          if (comparePrice) comparePrice.textContent = button.dataset.variantComparePrice;
          if (oneTimePrice) oneTimePrice.textContent = button.dataset.variantPrice;
          if (buttonPrice) buttonPrice.textContent = button.dataset.variantPrice;
          const submit = root.querySelector('[data-add-to-cart]');
          if (submit) submit.disabled = button.dataset.variantAvailable !== 'true';
          if (!selectMedia(button.dataset.variantMediaId) && button.dataset.variantImage) {
            const activeImage = root.querySelector('[data-media-panel].is-active img');
            if (activeImage) activeImage.src = button.dataset.variantImage;
          }
          if (modelTrigger) {
            modelTrigger.dataset.modelUrl = button.dataset.modelUrl || '';
            modelTrigger.hidden = !button.dataset.modelUrl && !modelTrigger.dataset.nativeModelId;
          }
        });
      });

      root.querySelectorAll('[data-plan-option]').forEach((input) => {
        input.addEventListener('change', () => {
          if (!sellingPlanInput) return;
          sellingPlanInput.value = input.value;
          sellingPlanInput.disabled = false;
          updateFrequencyCopy(input);
          if (refillPrice) refillPrice.textContent = input.dataset.planPrice;
          if (!pairedProducts && currentPrice) currentPrice.textContent = input.dataset.planPrice;
          if (!pairedProducts && buttonPrice) buttonPrice.textContent = input.dataset.planPrice;
        });
      });

      updateFrequencyCopy(root.querySelector('[data-plan-option]:checked'));
      syncTermsState(root.querySelector('[data-purchase-option]:checked')?.value === 'subscription');

      root.querySelector('[data-terms-open]')?.addEventListener('click', () => {
        if (!termsDialog || typeof termsDialog.showModal !== 'function') return;
        if (termsFrame && !termsFrame.getAttribute('src')) termsFrame.setAttribute('src', termsFrame.dataset.src);
        termsDialog.showModal();
      });
      root.querySelector('[data-terms-close]')?.addEventListener('click', () => termsDialog?.close());
      termsDialog?.addEventListener('click', (event) => {
        if (event.target === termsDialog) termsDialog.close();
      });

      root.querySelectorAll('[data-purchase-option]').forEach((input) => {
        input.addEventListener('change', () => {
          root.querySelectorAll('[data-purchase-card]').forEach((card) => card.classList.toggle('is-selected', card.dataset.purchaseCard === input.value));
          const subscription = input.value === 'subscription';
          if (sellingPlanInput) sellingPlanInput.disabled = !subscription;
          syncTermsState(subscription);
          if (!subscription) {
            const activeVariant = root.querySelector('[data-variant-option].is-active');
            if (currentPrice && activeVariant) currentPrice.textContent = activeVariant.dataset.variantPrice;
            if (buttonPrice && activeVariant) buttonPrice.textContent = activeVariant.dataset.variantPrice;
          } else if (pairedProducts) {
            const activeVariant = root.querySelector('[data-variant-option].is-active');
            if (currentPrice && activeVariant) currentPrice.textContent = activeVariant.dataset.variantPrice;
            if (buttonPrice && activeVariant) buttonPrice.textContent = activeVariant.dataset.variantPrice;
          } else {
            const activePlan = root.querySelector('[data-plan-option]:checked');
            if (!pairedProducts && buttonPrice && activePlan) buttonPrice.textContent = activePlan.dataset.planPrice;
          }
          if (error) error.hidden = true;
        });
      });

      if (form) {
        form.addEventListener('submit', async (event) => {
          const subscription = root.querySelector('[data-purchase-option]:checked')?.value === 'subscription';
          if (subscription && terms && !terms.checked) {
            event.preventDefault();
            error.hidden = false;
            terms.focus();
            return;
          }
          if (!pairedProducts) return;

          event.preventDefault();
          const submit = root.querySelector('[data-add-to-cart]');
          const mainVariantId = Number(variantInput?.value);
          const subscriptionVariantId = Number(root.dataset.subscriptionVariantId);
          const sellingPlanId = Number(sellingPlanInput?.value);
          if (!mainVariantId || (subscription && (!subscriptionVariantId || !sellingPlanId))) {
            if (error) {
              error.textContent = 'The selected subscription option is unavailable. Please refresh and try again.';
              error.hidden = false;
            }
            return;
          }

          const pairId = `ulike-subscription-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
          const items = subscription
            ? [
                {
                  id: mainVariantId,
                  quantity: 1,
                  properties: { _subscription_pair_id: pairId, _subscription_pair_role: 'main' }
                },
                {
                  id: subscriptionVariantId,
                  quantity: 1,
                  selling_plan: sellingPlanId,
                  properties: { _subscription_pair_id: pairId, _subscription_pair_role: 'subscription' }
                }
              ]
            : [{ id: mainVariantId, quantity: 1 }];

          if (submit) submit.disabled = true;
          if (error) error.hidden = true;
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items, sections: ['mini-cart'], sections_url: window.location.pathname })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this plan to cart.');
            const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
            const cart = await cartResponse.json();
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart, sections: result.sections, openMiniCart: true }
            }));
          } catch (submitError) {
            if (error) {
              error.textContent = submitError.message;
              error.hidden = false;
            }
          } finally {
            if (submit) submit.disabled = false;
          }
        });
      }

    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a10-2026-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-testimonial-scroller')) {
    customElements.define('ulike-testimonial-scroller', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-track]');
        this.previousButtons = this.querySelectorAll('[data-previous]');
        this.nextButtons = this.querySelectorAll('[data-next]');
        if (!this.track) return;
        this.previousButtons.forEach((button) => button.addEventListener('click', () => this.move(-1), options));
        this.nextButtons.forEach((button) => button.addEventListener('click', () => this.move(1), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.track.scrollTo({ left: 0, behavior: 'auto' });
          else if (event.key === 'End') this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'auto' });
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.querySelectorAll('[data-video-trigger]').forEach((button) => button.addEventListener('click', () => {
          const card = button.closest('[data-slide]');
          const video = card?.querySelector('video');
          const poster = card?.querySelector('[data-poster]');
          if (!video) return;
          poster?.setAttribute('hidden', '');
          video.hidden = false;
          button.hidden = true;
          card?.classList.add('is-playing');
          video.play().catch(() => {});
        }, options));
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.track);
        }
        this.update();
      }

      move(direction) {
        const slide = this.track.querySelector('[data-slide]');
        if (!slide) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const start = this.track.scrollLeft <= 2;
        const end = this.track.scrollLeft >= max - 2;
        this.previousButtons.forEach((button) => { button.disabled = start; });
        this.nextButtons.forEach((button) => { button.disabled = end; });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anniversary-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('anniversary-sticky-cart')) {
    customElements.define('anniversary-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        this.setAttribute('data-enhanced', '');
        this.updateVisibility = () => {
          this.frame = null;
          this.toggleAttribute('data-visible', window.scrollY >= 185);
        };
        this.onScroll = () => {
          if (this.frame == null) this.frame = requestAnimationFrame(this.updateVisibility);
        };
        window.addEventListener('scroll', this.onScroll, {passive: true});
        this.updateVisibility();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.frame != null) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ba26-fallback-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-blog-index')) {
    customElements.define('ulike-blog-index', class extends HTMLElement {
      connectedCallback() {
        const close = this.querySelector('.ubi-close');
        if (!close || close.dataset.ready) return;
        close.dataset.ready = 'true';
        close.hidden = false;
        close.addEventListener('click', () => {
          close.closest('aside').hidden = true;
          this.querySelector('.ubi-hero-link')?.focus({preventScroll: true});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bp26-fallback-1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-proof-carousel')) {
    class UlikeProofCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-proof-tab], [data-proof-thumbnail]'));
        this.panels = Array.from(this.querySelectorAll('[data-proof-panel]'));
        this.usesThumbnailNavigation = this.hasAttribute('data-thumbnail-navigation') && this.querySelector('[data-proof-thumbnail]');
        if (this.tabs.length) {
          this.setAttribute('data-enhanced', '');
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activateTab(index));
            tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, index));
          });
          this.activateTab(0);
        }
        this.querySelectorAll('[data-comparison]').forEach((comparison) => {
          const range = comparison.querySelector('[data-comparison-range]');
          if (!range) return;
          range.addEventListener('input', () => comparison.style.setProperty('--comparison-position', `${range.value}%`));
        });
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target.closest('[data-comparison-range]')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.viewport);
        }
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      activateTab(index, focus = false) {
        this.activeIndex = index;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex]?.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        this.tabs[index]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if (this.usesThumbnailNavigation) {
          const comparison = this.panels[index]?.querySelector('[data-comparison]');
          const range = comparison?.querySelector('[data-comparison-range]');
          if (comparison && range) {
            range.value = 50;
            comparison.style.setProperty('--comparison-position', '50%');
          }
          this.update();
        }
        if (focus) this.tabs[index]?.focus();
      }

      handleTabKeydown(event, index) {
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        this.activateTab(nextIndex, true);
      }

      move(direction) {
        if (this.usesThumbnailNavigation) {
          const nextIndex = Math.min(this.tabs.length - 1, Math.max(0, (this.activeIndex || 0) + direction));
          this.activateTab(nextIndex, true);
          return;
        }
        const card = this.viewport.querySelector('.ulike-product-proof__comparison');
        const list = this.viewport.querySelector('.ulike-product-proof__results-list');
        if (!card || !list) return;
        const gap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        if (!this.previousButton || !this.nextButton) return;
        if (this.usesThumbnailNavigation) {
          this.previousButton.disabled = (this.activeIndex || 0) === 0;
          this.nextButton.disabled = (this.activeIndex || 0) === this.tabs.length - 1;
          return;
        }
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = maximum <= 2 || this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-proof-carousel', UlikeProofCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edm-100-day-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindHeroSubscriptionForms = (root = document) => {
      root.querySelectorAll('[data-edm-hero-subscription-form]').forEach((form) => {
        if (form.dataset.bound === 'true') return;
        form.dataset.bound = 'true';

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('[type="submit"]');
          const error = form.querySelector('[data-form-error]');
          const originalLabel = button?.textContent;
          if (button) button.disabled = true;
          if (button) button.textContent = 'Adding…';
          if (error) {
            error.textContent = 'Adding to your cart…';
            error.hidden = false;
          }

          try {
            const shopifyRoot = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${shopifyRoot}cart/add.js`, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: new FormData(form)
            });
            const payload = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this item.');
            if (error) error.textContent = 'Added. Redirecting to your cart…';
            window.location.assign(`${shopifyRoot}cart`);
          } catch (exception) {
            if (error) {
              error.textContent = exception.message || error.textContent;
              error.hidden = false;
            }
            if (!error) window.alert(exception.message || 'Unable to add this item.');
            if (button) {
              button.disabled = false;
              button.textContent = originalLabel;
            }
          }
        });
      });
    };

    bindHeroSubscriptionForms();
    document.addEventListener('shopify:section:load', (event) => bindHeroSubscriptionForms(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edm-100-day-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindSubscriptionOffer = (root) => {
      const form = root.querySelector('[data-subscription-form]');
      if (!form || form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        const error = form.querySelector('[data-form-error]');
        const originalLabel = button?.textContent;
        if (button) button.disabled = true;
        if (button) button.textContent = 'Adding…';
        if (error) {
          error.textContent = 'Adding to your cart…';
          error.hidden = false;
        }

        try {
          const shopifyRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${shopifyRoot}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this item.');
          if (error) error.textContent = 'Added. Redirecting to your cart…';
          window.location.assign(`${shopifyRoot}cart`);
        } catch (exception) {
          if (error) {
            error.textContent = exception.message || error.textContent;
            error.hidden = false;
          }
          if (!error) window.alert(exception.message || 'Unable to add this item.');
          if (button) {
            button.disabled = false;
            button.textContent = originalLabel;
          }
        }
      });
    };

    document.querySelectorAll('[data-edm-subscription-offer]').forEach(bindSubscriptionOffer);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-edm-subscription-offer]');
      if (root) bindSubscriptionOffer(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const footerMediaQuery = window.matchMedia('(max-width: 740px)');

  const syncFooterDisclosureState = (event) => {
    document.querySelectorAll('.shopify-section--footer .footer__collapsible').forEach((disclosure, index) => {
      disclosure.open = event.matches ? index === 0 : true;
    });
  };

  syncFooterDisclosureState(footerMediaQuery);
  footerMediaQuery.addEventListener('change', syncFooterDisclosureState);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glow-plan-results"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-glow-plan-results]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[data-result-tab]')];
    const panels = [...root.querySelectorAll('[data-result-panel]')];
    const selectTab = (tab) => {
      const update = () => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
      };
      if (document.startViewTransition) document.startViewTransition(update);
      else update();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + direction + tabs.length) % tabs.length];
        selectTab(next);
        next.focus();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function updateAccountLogoutReturn(event) {
    const link = event.target.closest('a[data-account-logout]');
    if (!link) return;
    const logoutUrl = new URL(link.href, window.location.origin);
    if (logoutUrl.origin !== window.location.origin) return;
    logoutUrl.searchParams.set('return_url', window.location.pathname + window.location.search + window.location.hash);
    link.href = logoutUrl.href;
  }
  document.addEventListener('click', updateAccountLogoutReturn, true);
  document.addEventListener('auxclick', updateAccountLogoutReturn, true);
  document.addEventListener('contextmenu', updateAccountLogoutReturn, true);
  let accountLogoutPending = false;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[data-account-logout]');
    if (!link) return;
    event.preventDefault();
    if (accountLogoutPending) return;
    accountLogoutPending = true;
    link.setAttribute('aria-busy', 'true');
    link.parentElement.querySelector('[data-logout-error-message]')?.remove();
    try {
      const response = await fetch('https://api.ulike.com/user/logout?siteCode=US', {
        method: 'GET', credentials: 'include', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(15000)
      });
      if (!response.ok) throw Error('logout');
      const result = await response.json();
      if (Number(result.code) !== 0 || result.success === false) throw Error('logout');
      try {
        localStorage.removeItem('userInfo');
        localStorage.setItem('ulike:account-logout', String(Date.now()));
      } catch {}
      document.dispatchEvent(new Event('ulike:logout'));
      window.location.assign(link.href);
    } catch {
      const message = document.createElement('p');
      message.dataset.logoutErrorMessage = '';
      message.setAttribute('role', 'alert');
      message.textContent = link.dataset.logoutError;
      link.after(message);
    } finally {
      accountLogoutPending = false;
      link.removeAttribute('aria-busy');
    }
  }, true);
  window.addEventListener('storage', (event) => {
    if (event.key === 'ulike:account-logout' && event.newValue) {
      document.dispatchEvent(new Event('ulike:logout'));
      window.location.reload();
    }
  });


  const headerCartCounts = new WeakSet();
  const observeHeaderCartCounts = () => {
    document.querySelectorAll('.shopify-section--header .header__cart-count--floating').forEach((count) => {
      if (headerCartCounts.has(count)) return;
      headerCartCounts.add(count);
      const syncCount = () => count.setAttribute('cart', count.textContent.trim());
      syncCount();
      new MutationObserver(syncCount).observe(count, { childList: true, characterData: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeHeaderCartCounts, { once: true });
  else observeHeaderCartCounts();
  document.addEventListener('shopify:section:load', observeHeaderCartCounts);
  let regionReturnFocus;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[aria-controls="ulike-region-selector-popover"]');
    const dialog = document.getElementById('ulike-region-selector-popover');
    if (!dialog) return;
    if (trigger) {
      event.preventDefault();
      const drawer = trigger.closest('mobile-navigation');
      regionReturnFocus = drawer ? document.querySelector('[aria-controls="mobile-menu-drawer"]') : trigger;
      if (drawer) {
        drawer.open = false;
        document.body.appendChild(dialog);
      }
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
    } else if (event.target.closest('.ulike-region-selector__dialog [data-action="close"]') || event.target === dialog) {
      dialog.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.id === 'ulike-region-selector-popover') {
      document.querySelectorAll('[aria-controls="ulike-region-selector-popover"]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      regionReturnFocus?.focus();
    }
  }, true);
  document.addEventListener('pointerover', (event) => {
    const menu = event.target.closest('.ulike-account-menu');
    if (!menu || !window.matchMedia('(hover: hover)').matches) return;
    menu.querySelector('.ulike-account-menu__popover').setAttribute('open', '');
    menu.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'true');
  });
  document.addEventListener('pointerout', (event) => {
    const menu = event.target.closest('.ulike-account-menu');
    if (!menu || menu.contains(event.relatedTarget) || menu.contains(document.activeElement)) return;
    menu.querySelector('.ulike-account-menu__popover').removeAttribute('open');
    menu.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('focusin', (event) => {
    const menu = event.target.closest('.ulike-account-menu');
    if (!menu) return;
    menu.querySelector('.ulike-account-menu__popover').setAttribute('open', '');
    menu.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'true');
  });
  document.addEventListener('focusout', (event) => {
    const menu = event.target.closest('.ulike-account-menu');
    if (!menu || menu.contains(event.relatedTarget)) return;
    menu.querySelector('.ulike-account-menu__popover').removeAttribute('open');
    menu.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('keydown', (event) => {
    const menu = event.target.closest('.ulike-account-menu');
    if (!menu || event.key !== 'Escape') return;
    menu.querySelector('[aria-controls="ulike-account-popover"]').focus();
    menu.querySelector('.ulike-account-menu__popover').removeAttribute('open');
    menu.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-live-diagnosis"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-media-hero')) {
    customElements.define('ulike-media-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.update = () => {
          const allowed = this.visible && document.readyState === 'complete' && !document.hidden && !this.motion.matches && !navigator.connection?.saveData;
          if (!allowed) { this.video.pause(); return; }
          const source = this.video.querySelector('source[data-src]');
          if (source) { source.src = source.dataset.src; source.removeAttribute('data-src'); this.video.load(); }
          this.video.play().catch(() => {});
        };
        this.motion.addEventListener('change', this.update);
        window.addEventListener('load', this.update);
        document.addEventListener('visibilitychange', this.update);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
        if (!this.update) return;
        this.motion.removeEventListener('change', this.update);
        window.removeEventListener('load', this.update);
        document.removeEventListener('visibilitychange', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!customElements.get('ulike-article-contents')) {
    customElements.define('ulike-article-contents', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const body = this.querySelector('.rte');
        const details = this.querySelector('details');
        if (!body || !details) return;
        this.dataset.ready = 'true';
        const headings = [...body.querySelectorAll('h1,h2,h3,h4,h5,h6')].filter(el => el.textContent.trim());
        const normalize = value => value.replace(/\s+/g, ' ').trim();
        for (const link of body.querySelectorAll('a[href^="#"]')) {
          let id;
          try { id = decodeURIComponent(link.getAttribute('href').slice(1)); } catch { continue; }
          if (!id || document.getElementById(id)) continue;
          const matches = headings.filter(heading => normalize(heading.textContent) === normalize(link.textContent));
          if (matches.length !== 1) continue;
          const heading = matches[0];
          if (!heading.id) heading.id = id;
          else {
            const anchor = document.createElement('span');
            anchor.id = id;
            anchor.className = 'article-contents-anchor';
            heading.before(anchor);
          }
        }
        const list = details.querySelector('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = `${this.dataset.prefix}-${index + 1}`;
            while (document.getElementById(id)) id += '-next';
            heading.id = id;
          }
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        details.hidden = !headings.length;
        this.addEventListener('click', event => {
          const link = event.target.closest('a[href^="#"]');
          if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          let target;
          try { target = document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1))); } catch { return; }
          if (!target || !body.contains(target)) return;
          const hadTabindex = target.hasAttribute('tabindex');
          if (!hadTabindex) target.setAttribute('tabindex', '-1');
          target.focus({preventScroll: true});
          if (!hadTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once: true});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  if (!customElements.get('cart-affirm-message')) {
    customElements.define('cart-affirm-message', class extends HTMLElement {
      connectedCallback() {
        this.renderAttempts = 0;
        this.messageObserver = new MutationObserver(() => this.syncVisibility());
        const footer = this.closest('.drawer__footer');
        if (footer) this.messageObserver.observe(footer, { childList: true, subtree: true, characterData: true });
        this.syncVisibility();
        this.renderTimer = window.setTimeout(() => this.renderMessage(), 500);
      }

      disconnectedCallback() {
        window.clearTimeout(this.renderTimer);
        this.messageObserver?.disconnect();
      }

      syncVisibility() {
        const footer = this.closest('.drawer__footer');
        if (!footer) return;
        const messages = Array.from(footer.querySelectorAll('.affirm-as-low-as')).filter((message) => message.textContent.trim());
        const firstMessage = messages[0];
        const duplicate = Boolean(firstMessage && !this.contains(firstMessage));
        if (this.hidden !== duplicate) this.hidden = duplicate;
      }

      renderMessage() {
        if (!this.isConnected || this.querySelector('.affirm-as-low-as')) return;

        if (window.affirm && window.affirm.ui && window.affirm.ui.ready) {
          const message = document.createElement('p');
          message.className = 'affirm-as-low-as';
          message.dataset.amount = this.dataset.amount;
          message.dataset.affirmType = 'logo';
          message.dataset.affirmColor = 'blue';
          message.dataset.pageType = 'cart';
          this.appendChild(message);
          window.affirm.ui.ready(() => window.affirm.ui.refresh());
          return;
        }

        this.renderAttempts += 1;
        if (this.renderAttempts < 30) {
          this.renderTimer = window.setTimeout(() => this.renderMessage(), 100);
        }
      }
    });
  }

  function closeCartVariantPicker(picker, returnFocus) {
    if (!picker) return;
    const trigger = picker.querySelector('.ulike-cart-variant-picker__trigger');
    const options = picker.querySelector('.ulike-cart-variant-picker__options');
    if (!trigger || !options) return;
    trigger.setAttribute('aria-expanded', 'false');
    options.hidden = true;
    if (returnFocus) trigger.focus();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.ulike-cart-variant-picker__trigger');
    if (trigger) {
      const picker = trigger.closest('[data-variant-picker]');
      const options = picker.querySelector('.ulike-cart-variant-picker__options');
      const shouldOpen = options.hidden;
      document.querySelectorAll('[data-variant-picker]').forEach((otherPicker) => {
        if (otherPicker !== picker) closeCartVariantPicker(otherPicker, false);
      });
      trigger.setAttribute('aria-expanded', String(shouldOpen));
      options.hidden = !shouldOpen;
      if (shouldOpen) {
        const selectedOption = options.querySelector('[aria-selected="true"]');
        (selectedOption || options.querySelector('.ulike-cart-variant-picker__option:not(:disabled)'))?.focus();
      }
      return;
    }

    const option = event.target.closest('.ulike-cart-variant-picker__option');
    if (option && !option.disabled) {
      const picker = option.closest('[data-variant-picker]');
      const form = picker.closest('.ulike-cart-product__form');
      const card = picker.closest('.ulike-cart-product');
      const input = form.querySelector('.ulike-cart-product__variant-input');
      const triggerLabel = picker.querySelector('[data-variant-label]');
      const triggerSwatch = picker.querySelector('.ulike-cart-variant-picker__trigger .ulike-cart-variant-picker__swatch');
      const optionSwatch = option.querySelector('.ulike-cart-variant-picker__swatch');
      const image = card.querySelector('.ulike-cart-product__image');

      input.value = option.dataset.variantId;
      triggerLabel.textContent = option.dataset.variantLabel;
      triggerSwatch.style.cssText = optionSwatch.style.cssText;
      picker.querySelectorAll('.ulike-cart-variant-picker__option').forEach((item) => {
        const isSelected = item === option;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-selected', String(isSelected));
      });

      if (image && option.dataset.imageUrl) {
        image.removeAttribute('srcset');
        image.src = option.dataset.imageUrl;
      }
      closeCartVariantPicker(picker, true);
      return;
    }

    document.querySelectorAll('[data-variant-picker]').forEach((picker) => closeCartVariantPicker(picker, false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const picker = event.target.closest('[data-variant-picker]');
    if (picker) closeCartVariantPicker(picker, true);
  });
  if (!customElements.get('cart-countdown')) {
    customElements.define('cart-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        const duration = Math.max(1, Number(this.dataset.duration) || 15) * 60000;
        const key = this.dataset.storageKey || 'cart-countdown';
        let endTime = 0;

        try {
          endTime = Number(sessionStorage.getItem(key));
          if (!endTime || endTime <= Date.now()) {
            endTime = Date.now() + duration;
            sessionStorage.setItem(key, String(endTime));
          }
        } catch (error) {
          endTime = Date.now() + duration;
        }

        const update = () => {
          const remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 1000) * 1000);

          if (remaining === 0) {
            endTime = Date.now() + duration;
            try { sessionStorage.setItem(key, String(endTime)); } catch (error) {}
            update();
            return;
          }

          const minutes = Math.floor(remaining / 60000);
          const seconds = Math.floor((remaining % 60000) / 1000);
          const minuteNode = this.querySelector('[data-unit="minutes"]');
          const secondNode = this.querySelector('[data-unit="seconds"]');
          if (minuteNode) minuteNode.textContent = String(minutes).padStart(2, '0');
          if (secondNode) secondNode.textContent = String(seconds).padStart(2, '0');
        };

        update();
        this.timer = window.setInterval(update, 1000);
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc26-fallback-0"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-responsive-media-hero')) {
    customElements.define('ulike-responsive-media-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.mobile = matchMedia('(max-width: 740px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.isFirstSection = this.hasAttribute('data-first-section');
        this.visible = this.isFirstSection;

        this.onPlaying = () => this.setAttribute('data-video-playing', '');
        this.onVideoFailure = () => this.removeAttribute('data-video-playing');

        this.getSourceTemplate = () => {
          const requestedDevice = this.mobile.matches ? 'mobile' : 'desktop';
          return this.querySelector(`template[data-video-sources="${requestedDevice}"]`)
            || this.querySelector('template[data-video-sources="desktop"]')
            || this.querySelector('template[data-video-sources="mobile"]');
        };

        this.loadSelectedVideo = () => {
          const template = this.getSourceTemplate();
          if (!template) return false;

          const sourceData = [...template.content.querySelectorAll('source[data-src]')];
          const sourceKey = sourceData.map(source => `${source.dataset.src}|${source.type}`).join(',');
          if (!sourceKey) return false;
          if (sourceKey === this.activeSourceKey) return true;

          this.video.pause();
          this.removeAttribute('data-video-playing');
          this.video.replaceChildren(...sourceData.map(sourceDataItem => {
            const source = document.createElement('source');
            source.src = sourceDataItem.dataset.src;
            if (sourceDataItem.type) source.type = sourceDataItem.type;
            return source;
          }));
          this.activeSourceKey = sourceKey;
          this.video.load();
          return true;
        };

        this.update = () => {
          const shouldLoad = this.isFirstSection || this.visible;
          const allowed = shouldLoad && !document.hidden && !this.motion.matches && !navigator.connection?.saveData;
          if (!allowed) { this.video.pause(); return; }
          if (!this.loadSelectedVideo()) return;
          this.video.play().catch(this.onVideoFailure);
        };

        this.onBreakpointChange = () => {
          this.update();
        };

        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('error', this.onVideoFailure);
        this.mobile.addEventListener('change', this.onBreakpointChange);
        this.motion.addEventListener('change', this.update);
        document.addEventListener('visibilitychange', this.update);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        });
        this.observer.observe(this);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
        if (!this.update) return;
        this.video.removeEventListener('playing', this.onPlaying);
        this.video.removeEventListener('error', this.onVideoFailure);
        this.mobile.removeEventListener('change', this.onBreakpointChange);
        this.motion.removeEventListener('change', this.update);
        document.removeEventListener('visibilitychange', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc26-fallback-1"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pcos-dialog-open]').forEach((button)=>button.addEventListener('click',()=>document.getElementById(button.dataset.pcosDialogOpen).showModal()));document.querySelectorAll('[data-pcos-dialog-close]').forEach((button)=>button.addEventListener('click',()=>button.closest('dialog').close()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc26-fallback-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-showcase')) {
    customElements.define('product-showcase', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const swatch = event.target.closest('[data-showcase-swatch]');
          if (!swatch || !this.contains(swatch)) return;
          const card = swatch.closest('.ulike-product-showcase__card');
          const index = swatch.dataset.showcaseSwatch;
          card.querySelectorAll('[data-showcase-swatch]').forEach((button) => button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false'));
          card.querySelectorAll('[data-showcase-image]').forEach((media) => { media.hidden = media.dataset.showcaseImage !== index; });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc26-fallback-3"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    const track = event.target.closest('[data-story-cards-track]');
    if (!track || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    if (track.scrollWidth <= track.clientWidth) return;
    event.preventDefault();
    const card = track.querySelector('.ulike-story-cards__card');
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const direction = event.key === 'ArrowLeft' ? -1 : 1;
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc26-fallback-7"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-expert-carousel')) {
    class UlikeExpertCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        new ResizeObserver(() => this.update()).observe(this.viewport);
        this.update();
      }

      move(direction) {
        const card = this.viewport.querySelector('.ulike-experts__card');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(this.viewport.querySelector('.ulike-experts__track')).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-expert-carousel', UlikeExpertCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc26-fallback-8"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-proof-carousel')) {
    class UlikeProofCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-proof-tab], [data-proof-thumbnail]'));
        this.panels = Array.from(this.querySelectorAll('[data-proof-panel]'));
        this.usesThumbnailNavigation = this.hasAttribute('data-thumbnail-navigation') && this.querySelector('[data-proof-thumbnail]');
        if (this.tabs.length) {
          this.setAttribute('data-enhanced', '');
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activateTab(index));
            tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, index));
          });
          this.activateTab(0);
        }
        this.querySelectorAll('[data-comparison]').forEach((comparison) => {
          const range = comparison.querySelector('[data-comparison-range]');
          if (!range) return;
          range.addEventListener('input', () => comparison.style.setProperty('--comparison-position', `${range.value}%`));
        });
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target.closest('[data-comparison-range]')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.viewport);
        }
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      activateTab(index, focus = false) {
        this.activeIndex = index;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex]?.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        this.tabs[index]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if (this.usesThumbnailNavigation) {
          const comparison = this.panels[index]?.querySelector('[data-comparison]');
          const range = comparison?.querySelector('[data-comparison-range]');
          if (comparison && range) {
            range.value = 50;
            comparison.style.setProperty('--comparison-position', '50%');
          }
          this.update();
        }
        if (focus) this.tabs[index]?.focus();
      }

      handleTabKeydown(event, index) {
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        this.activateTab(nextIndex, true);
      }

      move(direction) {
        if (this.usesThumbnailNavigation) {
          const nextIndex = Math.min(this.tabs.length - 1, Math.max(0, (this.activeIndex || 0) + direction));
          this.activateTab(nextIndex, true);
          return;
        }
        const card = this.viewport.querySelector('.ulike-product-proof__comparison');
        const list = this.viewport.querySelector('.ulike-product-proof__results-list');
        if (!card || !list) return;
        const gap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        if (!this.previousButton || !this.nextButton) return;
        if (this.usesThumbnailNavigation) {
          this.previousButton.disabled = (this.activeIndex || 0) === 0;
          this.nextButton.disabled = (this.activeIndex || 0) === this.tabs.length - 1;
          return;
        }
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = maximum <= 2 || this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-proof-carousel', UlikeProofCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["preheat-specialist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-preheat-specialist')) {
    class PreheatSpecialist extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.preheat-specialist-img');
        this.slides = Array.from(this.querySelectorAll('.preheat-specialist-img-item'));
        this.texts = Array.from(this.querySelectorAll('.preheat-specialist-text-item'));
        this.thumbnails = Array.from(this.querySelectorAll('.preheat-specialist-sm-item'));
        if (!this.track || !this.slides.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.index = 0;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        const arrows = this.querySelectorAll('.preheat-specialist-arraw-item');
        const makeButton = (element, label, action) => {
          element.setAttribute('role', 'button');
          element.setAttribute('tabindex', '0');
          element.setAttribute('aria-label', label);
          element.addEventListener('click', action, { signal });
          element.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            action();
          }, { signal });
        };
        arrows.forEach((arrow, index) => {
          makeButton(arrow, index ? 'Next expert' : 'Previous expert', () => this.select(this.index + (index ? 1 : -1)));
          arrow.hidden = this.slides.length < 2;
        });
        this.thumbnails.forEach((thumbnail, index) => {
          const name = this.texts[index]?.querySelector('.preheat-specialist-name')?.textContent.trim();
          makeButton(thumbnail, name || `Expert ${index + 1}`, () => this.select(index));
        });
        const viewport = this.querySelector('.preheat-specialist-cont');
        viewport.addEventListener('touchstart', (event) => {
          this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, { passive: true, signal });
        viewport.addEventListener('touchend', (event) => {
          if (!this.touchStart) return;
          const dx = event.changedTouches[0].clientX - this.touchStart.x;
          const dy = event.changedTouches[0].clientY - this.touchStart.y;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.select(this.index + (dx < 0 ? 1 : -1));
          this.touchStart = null;
        }, { passive: true, signal });
        viewport.addEventListener('touchcancel', () => { this.touchStart = null; }, { passive: true, signal });
        this.addEventListener('mouseenter', () => this.stop(), { signal });
        this.addEventListener('mouseleave', () => this.start(), { signal });
        this.addEventListener('focusin', () => this.stop(), { signal });
        this.addEventListener('focusout', () => requestAnimationFrame(() => { if (!signal.aborted) this.start(); }), { signal });
        document.addEventListener('visibilitychange', () => this.start(), { signal });
        this.reducedMotion.addEventListener('change', () => { this.render(); this.start(); }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.select(index); this.stop(); }
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.render(false));
        this.resizeObserver.observe(this.slides[0]);
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.start();
        });
        this.visibilityObserver.observe(this);
        this.render(false);
      }
      select(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.render();
        this.start();
      }
      render(animate = true) {
        this.track.style.transition = animate && !this.reducedMotion.matches ? 'transform 400ms ease' : 'none';
        this.track.style.transform = `translateX(-${this.index * this.slides[0].getBoundingClientRect().width}px)`;
        this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.index)));
        this.texts.forEach((text, index) => {
          text.classList.toggle('active', index === this.index);
          text.inert = index !== this.index;
          text.setAttribute('aria-hidden', String(index !== this.index));
        });
        this.thumbnails.forEach((thumbnail, index) => {
          thumbnail.classList.toggle('active', index === this.index);
          thumbnail.setAttribute('aria-pressed', String(index === this.index));
        });
      }
      start() {
        this.stop();
        if (this.slides.length < 2 || !this.visible || document.hidden || this.reducedMotion.matches || this.matches(':hover') || this.contains(document.activeElement)) return;
        this.timer = setTimeout(() => this.select(this.index + 1), 3000);
      }
      stop() { clearTimeout(this.timer); }
      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }
    }
    customElements.define('ulike-preheat-specialist', PreheatSpecialist);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps26-fallback-article-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-article-recommendations')) {
    customElements.define('ulike-article-recommendations', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.uar-track');
        const controls = this.querySelector('.uar-controls');
        if (!track || !controls) return;
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const {signal} = this.controller;
        const previous = controls.querySelector('[data-direction="-1"]');
        const next = controls.querySelector('[data-direction="1"]');
        const update = () => {
          const extent = track.scrollWidth - track.clientWidth;
          controls.hidden = extent < 2;
          previous.disabled = Math.abs(track.scrollLeft) < 2;
          next.disabled = Math.abs(track.scrollLeft) >= extent - 2;
        };
        controls.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || button.disabled) return;
          const card = track.querySelector('.uar-card');
          const style = getComputedStyle(track);
          const step = (card?.getBoundingClientRect().width || track.clientWidth) + parseFloat(style.columnGap || 0);
          track.scrollBy({left: step * Number(button.dataset.direction) * (style.direction === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }, {signal});
        track.addEventListener('scroll', update, {passive: true, signal});
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps26-fallback-main"]) return;
  try {
    
  if (!customElements.get('ulike-article-contents')) {
    customElements.define('ulike-article-contents', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const body = this.querySelector('.rte');
        const details = this.querySelector('details');
        if (!body || !details) return;
        this.dataset.ready = 'true';
        const headings = [...body.querySelectorAll('h1,h2,h3,h4,h5,h6')].filter(el => el.textContent.trim());
        const normalize = value => value.replace(/\s+/g, ' ').trim();
        for (const link of body.querySelectorAll('a[href^="#"]')) {
          let id;
          try { id = decodeURIComponent(link.getAttribute('href').slice(1)); } catch { continue; }
          if (!id || document.getElementById(id)) continue;
          const matches = headings.filter(heading => normalize(heading.textContent) === normalize(link.textContent));
          if (matches.length !== 1) continue;
          const heading = matches[0];
          if (!heading.id) heading.id = id;
          else {
            const anchor = document.createElement('span');
            anchor.id = id;
            anchor.className = 'article-contents-anchor';
            heading.before(anchor);
          }
        }
        const list = details.querySelector('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) {
            let id = `${this.dataset.prefix}-${index + 1}`;
            while (document.getElementById(id)) id += '-next';
            heading.id = id;
          }
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${encodeURIComponent(heading.id)}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        details.hidden = !headings.length;
        this.addEventListener('click', event => {
          const link = event.target.closest('a[href^="#"]');
          if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          let target;
          try { target = document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1))); } catch { return; }
          if (!target || !body.contains(target)) return;
          const hadTabindex = target.hasAttribute('tabindex');
          if (!hadTabindex) target.setAttribute('tabindex', '-1');
          target.focus({preventScroll: true});
          if (!hadTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once: true});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safeguards-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-safeguards')) {
    class UlikeSafeguards extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const message = this.querySelector('.safeguards-new-msg');
        if (!message) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const mobile = matchMedia('(max-width: 641px)');
        const hide = () => { message.style.display = 'none'; };
        const show = (item) => {
          message.querySelector('.safeguards-new-msg-txt').textContent = item.dataset.txt;
          message.querySelector('.safeguards-new-msg-top span').textContent = item.querySelector('.safeguards-new-h3').textContent;
          if (!mobile.matches) {
            const rect = item.getBoundingClientRect();
            message.style.left = rect.left + 'px';
            message.style.top = rect.bottom + 20 + 'px';
            message.style.width = rect.width + 'px';
          } else {
            message.style.removeProperty('left');
            message.style.removeProperty('top');
            message.style.removeProperty('width');
          }
          message.style.display = 'block';
        };
        this.querySelectorAll('[data-txt]').forEach((item) => {
          item.tabIndex = 0;
          item.addEventListener('mouseenter', () => { if (!mobile.matches) show(item); }, { signal });
          item.addEventListener('mouseleave', () => { if (!mobile.matches) hide(); }, { signal });
          item.addEventListener('focus', () => show(item), { signal });
          item.addEventListener('blur', () => { if (!mobile.matches) hide(); }, { signal });
          item.addEventListener('click', () => { if (mobile.matches) show(item); }, { signal });
          item.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault(); show(item);
          }, { signal });
        });
        message.addEventListener('click', hide, { signal });
        document.addEventListener('keydown', (event) => { if (event.key === 'Escape') hide(); }, { signal });
        window.addEventListener('scroll', () => { if (!mobile.matches) hide(); }, { passive: true, signal });
        mobile.addEventListener('change', hide, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    }
    customElements.define('ulike-safeguards', UlikeSafeguards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slashed-price-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-slp-buy]').forEach((button) => {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const purchase = document.querySelector('[data-subscription-purchase]');
        if (!purchase) return;
        const subscription = purchase.querySelector('[data-purchase-option][value="subscription"]');
        if (subscription && !subscription.checked) {
          subscription.checked = true;
          subscription.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const terms = purchase.querySelector('[data-subscription-terms]');
        if (terms && !terms.checked) {
          terms.checked = true;
          terms.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const addButton = purchase.querySelector('[data-add-to-cart]');
        if (addButton && !addButton.disabled) {
          addButton.click();
          return;
        }
        purchase.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slashed-prices-r2-additions"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('click',function(event){
  const link=event.target.closest('[data-slashed-r2-buy]');
  if(!link)return;
  const buy=document.getElementById('GlowPlanPurchase');
  if(!buy)return;
  event.preventDefault();
  const offset=parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'),10)||100;
  window.scrollTo({top:Math.max(0,buy.getBoundingClientRect().top+window.scrollY-offset-16),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slashed-prices-r2-page"] && !Shopify.designMode) return;
  try {
    
(function(){
 document.addEventListener('click',function(event){
  const link=event.target.closest('[data-sfp-buy]');if(!link)return;
  const buy=document.getElementById('GlowPlanPurchase');if(!buy)return;
  event.preventDefault();
  const offset=parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'),10)||100;
  window.scrollTo({top:Math.max(0,buy.getBoundingClientRect().top+window.scrollY-offset-16),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
 });
 function initializeSticky(){
  const bar=document.querySelector('.sfp-sticky-controller'),hero=document.getElementById('sfp-top'),buy=document.getElementById('GlowPlanPurchase');
  if(!bar||!hero||!buy||bar.dataset.initialized==='true')return;
  bar.dataset.initialized='true';
  if(!('IntersectionObserver' in window)){bar.classList.add('is-on');return;}
  let heroVisible=true,buyVisible=false;
  const sync=()=>{const shown=!heroVisible&&!buyVisible;bar.classList.toggle('is-on',shown);bar.inert=!shown;bar.setAttribute('aria-hidden',String(!shown));};
  new IntersectionObserver(es=>{heroVisible=es[0].isIntersecting;sync();}).observe(hero);
  new IntersectionObserver(es=>{buyVisible=es[0].isIntersecting;sync();},{threshold:.25}).observe(buy);
  sync();
 }
 initializeSticky();document.addEventListener('shopify:section:load',initializeSticky);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-purchase-module"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-subscription-purchase]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const reviewsLink = root.querySelector('[data-reviews-link]');
      if (reviewsLink) {
        const findReviewsTarget = () => {
          const targetId = reviewsLink.dataset.targetId.trim().replace(/^#/, '');
          return document.getElementById(targetId) || [...document.querySelectorAll('[id^="shopify-section-"]')].find((element) => element.id.endsWith(`__${targetId}`));
        };
        const initialReviewsTarget = findReviewsTarget();
        if (initialReviewsTarget) reviewsLink.setAttribute('href', `#${initialReviewsTarget.id}`);
        reviewsLink.addEventListener('click', (event) => {
          const target = findReviewsTarget();
          if (!target) return;
          event.preventDefault();
          const offset = Number(reviewsLink.dataset.scrollOffset) || 0;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: Math.max(0, top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          history.replaceState(null, '', `#${encodeURIComponent(target.id)}`);
        });
      }
      const form = root.querySelector('[data-product-form]');
      const variantInput = root.querySelector('[data-variant-id]');
      const sellingPlanInput = root.querySelector('[data-selling-plan]');
      const terms = root.querySelector('[data-subscription-terms]');
      const termsWrap = root.querySelector('[data-subscription-terms-wrap]');
      const error = root.querySelector('[data-form-error]');
      const buttonPrice = root.querySelector('[data-button-price]');
      const currentPrice = root.querySelector('[data-current-price]');
      const comparePrice = root.querySelector('[data-compare-price]');
      const sticky = root.querySelector('[data-mobile-sticky]');
      const stickyButton = root.querySelector('[data-mobile-sticky-submit]');
      const submitButton = root.querySelector('[data-add-to-cart]');

      const syncSubmitAvailability = () => {
        if (!submitButton || root.dataset.submitting === 'true') return;
        const subscriptionSelected = root.querySelector('[data-purchase-option]:checked')?.value === 'subscription';
        const variantAvailable = root.dataset.variantAvailable === 'true';
        const planAvailable = !subscriptionSelected || (root.dataset.subscriptionAvailable === 'true' && Boolean(sellingPlanInput?.value));
        const disabled = !variantAvailable || !planAvailable;
        if (submitButton.disabled !== disabled) submitButton.disabled = disabled;
      };
      if (submitButton) {
        new MutationObserver(syncSubmitAvailability).observe(submitButton, { attributes: true, attributeFilter: ['disabled'] });
        syncSubmitAvailability();
      }

      stickyButton?.addEventListener('click', () => submitButton?.click());
      if (sticky && submitButton) {
        sticky.hidden = false;
        const stickyObserver = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: 0.05 });
        stickyObserver.observe(submitButton);
      }
      const mediaPanels = [...root.querySelectorAll('[data-media-panel]')];
      const mediaButtons = [...root.querySelectorAll('[data-gallery-media]')];
      const thumbnailRail = root.querySelector('.subscription-purchase__thumbnails');
      const primaryMedia = root.querySelector('[data-primary-media]');
      const pairedProducts = root.dataset.purchaseMode === 'paired_products';
      const configuredDiscountCode = root.dataset.discountCode?.trim();
      const configuredOneTimePrice = root.dataset.oneTimePrice?.trim();
      const limitSubscriptionQuantity = root.dataset.limitSubscriptionQuantity === 'true';
      const duplicateSubscriptionMessage = root.dataset.duplicateSubscriptionMessage || 'This subscription plan is already in your cart.';
      const limitedSubscriptionProperty = '_subscription_limit_one';
      const frequencyCopyNodes = [...root.querySelectorAll('[data-frequency-copy]')];
      const termsDialog = root.querySelector('[data-terms-dialog]');
      const termsContent = root.querySelector('[data-terms-content]');
      const termsFallback = root.querySelector('[data-terms-fallback]');

      frequencyCopyNodes.forEach((node) => {
        node.dataset.frequencyTemplate = node.textContent.trim();
      });

      const updateFrequencyCopy = (planInput) => {
        const planLabel = planInput?.nextElementSibling?.textContent || planInput?.dataset.planName || '';
        const monthMatch = planLabel.match(/(\d+)\s*(?:mo(?:nth)?s?)/i);
        if (!monthMatch) return;
        const monthCount = Number(monthMatch[1]);
        const replacement = `every ${monthCount} ${monthCount === 1 ? 'month' : 'months'}`;
        frequencyCopyNodes.forEach((node) => {
          node.textContent = node.dataset.frequencyTemplate.replace(/every\s+\d+\s+months?/gi, replacement);
        });
      };

      const syncTermsState = (subscription) => {
        if (!terms) return;
        terms.required = subscription;
        terms.disabled = !subscription;
        terms.checked = subscription;
        if (termsWrap) termsWrap.hidden = !subscription;
      };

      const selectMedia = (mediaId) => {
        if (!mediaId) return false;
        const panel = mediaPanels.find((item) => item.dataset.mediaPanel === String(mediaId));
        if (!panel) return false;
        if (panel.dataset.mediaType === 'model') {
          ensureModelViewer().catch(() => {
            const status = root.querySelector('[data-share-status]');
            if (status) status.textContent = 'Unable to load 360° view. Please try again.';
          });
        }
        mediaPanels.forEach((item) => {
          const active = item === panel;
          item.classList.toggle('is-active', active);
          item.hidden = !active;
          if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
        });
        mediaButtons.forEach((item) => {
          const active = item.dataset.galleryMedia === String(mediaId);
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active && window.matchMedia('(max-width: 989px)').matches) {
            item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
        return true;
      };

      if (thumbnailRail) {
        let dragStartX = 0;
        let dragStartY = 0;
        let dragScrollLeft = 0;
        let dragScrollTop = 0;
        let isDragging = false;
        let suppressClick = false;
        let activePointerId = null;

        thumbnailRail.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          activePointerId = event.pointerId;
          dragStartX = event.clientX;
          dragStartY = event.clientY;
          dragScrollLeft = thumbnailRail.scrollLeft;
          dragScrollTop = thumbnailRail.scrollTop;
          isDragging = false;
          suppressClick = false;
        });
        thumbnailRail.addEventListener('pointermove', (event) => {
          if (activePointerId !== event.pointerId) return;
          const deltaX = event.clientX - dragStartX;
          const deltaY = event.clientY - dragStartY;
          const mobileRail = window.matchMedia('(max-width: 989px)').matches;
          if (!isDragging && mobileRail && Math.abs(deltaY) > Math.abs(deltaX)) {
            activePointerId = null;
            return;
          }
          if (!isDragging && Math.hypot(deltaX, deltaY) < 5) return;
          if (!isDragging) {
            isDragging = true;
            thumbnailRail.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          if (mobileRail) thumbnailRail.scrollLeft = dragScrollLeft - deltaX;
          else thumbnailRail.scrollTop = dragScrollTop - deltaY;
        });
        thumbnailRail.addEventListener('pointerup', (event) => {
          if (activePointerId !== event.pointerId) return;
          suppressClick = isDragging;
          if (thumbnailRail.hasPointerCapture(event.pointerId)) thumbnailRail.releasePointerCapture(event.pointerId);
          isDragging = false;
          activePointerId = null;
        });
        thumbnailRail.addEventListener('pointercancel', () => {
          isDragging = false;
          activePointerId = null;
        });
        thumbnailRail.addEventListener('click', (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          suppressClick = false;
        }, true);
      }

      mediaButtons.forEach((button) => button.addEventListener('click', () => selectMedia(button.dataset.galleryMedia)));

      if (primaryMedia) {
        let mediaPointerId = null;
        let mediaStartX = 0;
        let mediaStartY = 0;
        let mediaDragging = false;
        let draggedPanel = null;

        const resetMediaDrag = () => {
          if (draggedPanel) {
            draggedPanel.style.transform = '';
            draggedPanel.style.transition = '';
          }
          draggedPanel = null;
          mediaDragging = false;
          mediaPointerId = null;
        };

        primaryMedia.addEventListener('pointerdown', (event) => {
          if (!window.matchMedia('(max-width: 989px)').matches || !event.isPrimary) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest('video, iframe, model-viewer, button')) return;
          mediaPointerId = event.pointerId;
          mediaStartX = event.clientX;
          mediaStartY = event.clientY;
          mediaDragging = false;
          draggedPanel = root.querySelector('[data-media-panel].is-active');
        });
        primaryMedia.addEventListener('pointermove', (event) => {
          if (mediaPointerId !== event.pointerId || !draggedPanel) return;
          const deltaX = event.clientX - mediaStartX;
          const deltaY = event.clientY - mediaStartY;
          if (!mediaDragging && Math.abs(deltaY) > Math.abs(deltaX)) {
            resetMediaDrag();
            return;
          }
          if (!mediaDragging && Math.abs(deltaX) < 6) return;
          if (!mediaDragging) {
            mediaDragging = true;
            primaryMedia.setPointerCapture(event.pointerId);
            draggedPanel.style.transition = 'none';
          }
          event.preventDefault();
          draggedPanel.style.transform = `translate3d(${deltaX}px, 0, 0)`;
        });
        primaryMedia.addEventListener('pointerup', (event) => {
          if (mediaPointerId !== event.pointerId) return;
          const deltaX = event.clientX - mediaStartX;
          const deltaY = event.clientY - mediaStartY;
          const currentIndex = mediaPanels.findIndex((panel) => panel.classList.contains('is-active'));
          const shouldChange = mediaDragging && Math.abs(deltaX) >= 45 && Math.abs(deltaX) > Math.abs(deltaY);
          const nextIndex = shouldChange
            ? Math.max(0, Math.min(mediaPanels.length - 1, currentIndex + (deltaX < 0 ? 1 : -1)))
            : currentIndex;
          if (primaryMedia.hasPointerCapture(event.pointerId)) primaryMedia.releasePointerCapture(event.pointerId);
          resetMediaDrag();
          if (nextIndex !== currentIndex) selectMedia(mediaPanels[nextIndex].dataset.mediaPanel);
        });
        primaryMedia.addEventListener('pointercancel', resetMediaDrag);
      }

      root.querySelector('[data-product-share]')?.addEventListener('click', async () => {
        const shareData = { title: root.dataset.productTitle, url: window.location.href };
        const status = root.querySelector('[data-share-status]');
        try {
          if (navigator.share) await navigator.share(shareData);
          else {
            await navigator.clipboard.writeText(shareData.url);
            if (status) status.textContent = 'Link copied';
          }
        } catch (error) {
          if (error?.name !== 'AbortError' && status) status.textContent = 'Copy the page URL to share';
        }
        if (status?.textContent) window.setTimeout(() => { status.textContent = ''; }, 2400);
      });

      const modelTrigger = root.querySelector('[data-model-trigger]');
      const modelOverlay = root.querySelector('[data-external-model]');
      const modelViewer = root.querySelector('[data-model-viewer]');
      const modelStatus = root.querySelector('[data-model-status]');
      const ensureModelViewer = () => {
        if (window.customElements.get('model-viewer')) return Promise.resolve();
        if (!window.__ulikeModelViewerPromise) {
          window.__ulikeModelViewerPromise = import('https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js').catch((error) => {
            delete window.__ulikeModelViewerPromise;
            throw error;
          });
        }
        return window.__ulikeModelViewerPromise;
      };
      if (root.querySelector('[data-media-panel].is-active[data-media-type="model"]')) {
        ensureModelViewer().catch(() => {});
      }
      modelTrigger?.addEventListener('click', async () => {
        const modelUrl = modelTrigger.dataset.modelUrl;
        if (modelUrl && modelOverlay && modelViewer) {
          modelOverlay.hidden = false;
          if (modelStatus) modelStatus.textContent = 'Loading 360° view…';
          modelOverlay.setAttribute('aria-busy', 'true');
          try {
            await ensureModelViewer();
            if (modelOverlay.hidden || modelTrigger.dataset.modelUrl !== modelUrl) return;
            modelViewer.setAttribute('src', modelUrl);
            if (modelStatus) modelStatus.textContent = '';
          } catch (error) {
            if (!modelOverlay.hidden && modelStatus) modelStatus.textContent = 'Unable to load 360° view. Please close and try again.';
          } finally {
            modelOverlay.removeAttribute('aria-busy');
          }
          return;
        }
        if (modelTrigger.dataset.nativeModelId) {
          try {
            await ensureModelViewer();
            selectMedia(modelTrigger.dataset.nativeModelId);
          } catch (error) {
            const status = root.querySelector('[data-share-status]');
            if (status) status.textContent = 'Unable to load 360° view. Please try again.';
          }
        }
      });
      root.querySelector('[data-model-close]')?.addEventListener('click', () => {
        if (modelOverlay) modelOverlay.hidden = true;
        if (modelViewer) modelViewer.removeAttribute('src');
      });

      root.querySelectorAll('[data-variant-option]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-variant-option]').forEach((item) => {
            item.classList.toggle('is-active', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });
          variantInput.value = button.dataset.variantId;
          root.dataset.variantAvailable = button.dataset.variantAvailable;
          const subscriptionSelected = root.querySelector('[data-purchase-option]:checked')?.value === 'subscription';
          if (currentPrice) currentPrice.textContent = pairedProducts && subscriptionSelected ? root.dataset.subscriptionPrice : button.dataset.variantPrice;
          if (comparePrice) comparePrice.textContent = button.dataset.variantComparePrice;
          if (buttonPrice) buttonPrice.textContent = pairedProducts && subscriptionSelected ? root.dataset.subscriptionPrice : button.dataset.variantPrice;
          syncSubmitAvailability();
          if (!selectMedia(button.dataset.variantMediaId) && button.dataset.variantImage) {
            const activeImage = root.querySelector('[data-media-panel].is-active img');
            if (activeImage) activeImage.src = button.dataset.variantImage;
          }
          if (modelTrigger) {
            modelTrigger.dataset.modelUrl = button.dataset.modelUrl || '';
            modelTrigger.hidden = !button.dataset.modelUrl && !modelTrigger.dataset.nativeModelId;
          }
        });
      });

      root.querySelectorAll('[data-plan-option]').forEach((input) => {
        input.addEventListener('change', () => {
          if (!sellingPlanInput) return;
          sellingPlanInput.value = input.value;
          sellingPlanInput.disabled = false;
          updateFrequencyCopy(input);
          if (!pairedProducts && currentPrice) currentPrice.textContent = input.dataset.planPrice;
          if (!pairedProducts && buttonPrice) buttonPrice.textContent = input.dataset.planPrice;
        });
      });

      updateFrequencyCopy(root.querySelector('[data-plan-option]:checked'));
      syncTermsState(root.querySelector('[data-purchase-option]:checked')?.value === 'subscription');

      const loadTermsContent = async () => {
        if (!termsContent || termsContent.dataset.loaded === 'true' || termsContent.dataset.loading === 'true') return;
        termsContent.dataset.loading = 'true';
        termsContent.setAttribute('aria-busy', 'true');
        try {
          const sourceUrl = new URL(termsContent.dataset.src, window.location.href);
          if (sourceUrl.origin !== window.location.origin) throw new Error('Terms content must use the storefront domain.');
          const response = await fetch(sourceUrl.href, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Unable to load terms content.');
          const documentHtml = new DOMParser().parseFromString(await response.text(), 'text/html');
          const sourceContent = documentHtml.querySelector('.page-content') || documentHtml.querySelector('[role="main"]');
          if (!sourceContent) throw new Error('Terms page content was not found.');

          const importedContent = document.importNode(sourceContent, true);
          importedContent.querySelectorAll('script, style, link, iframe, object, embed, form, dialog, noscript').forEach((element) => element.remove());
          importedContent.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
          importedContent.querySelectorAll('[href], [src]').forEach((element) => {
            ['href', 'src'].forEach((attribute) => {
              const value = element.getAttribute(attribute);
              if (!value) return;
              const absoluteUrl = new URL(value, sourceUrl);
              if (absoluteUrl.protocol === 'http:' || absoluteUrl.protocol === 'https:') element.setAttribute(attribute, absoluteUrl.href);
              else element.removeAttribute(attribute);
            });
            if (element.matches('a[href]')) {
              element.setAttribute('target', '_blank');
              element.setAttribute('rel', 'noopener');
            }
          });
          termsContent.replaceChildren(importedContent);
          termsContent.dataset.loaded = 'true';
        } catch (loadError) {
          if (termsFallback) termsFallback.hidden = false;
          termsContent.dispatchEvent(new CustomEvent('terms:load-error', { bubbles: true, detail: { error: loadError } }));
        } finally {
          termsContent.dataset.loading = 'false';
          termsContent.setAttribute('aria-busy', 'false');
        }
      };

      root.querySelector('[data-terms-open]')?.addEventListener('click', () => {
        if (!termsDialog || typeof termsDialog.showModal !== 'function') return;
        termsDialog.showModal();
        loadTermsContent();
      });
      root.querySelector('[data-terms-close]')?.addEventListener('click', () => termsDialog?.close());
      termsDialog?.addEventListener('click', (event) => {
        if (event.target === termsDialog) termsDialog.close();
      });

      root.querySelectorAll('[data-purchase-option]').forEach((input) => {
        input.addEventListener('change', () => {
          root.querySelectorAll('[data-purchase-card]').forEach((card) => card.classList.toggle('is-selected', card.dataset.purchaseCard === input.value));
          const subscription = input.value === 'subscription';
          if (sellingPlanInput) sellingPlanInput.disabled = !subscription;
          syncTermsState(subscription);
          if (!subscription) {
            const activeVariant = root.querySelector('[data-variant-option].is-active');
            const oneTimePrice = activeVariant?.dataset.variantPrice || configuredOneTimePrice;
            if (currentPrice && oneTimePrice) currentPrice.textContent = oneTimePrice;
            if (buttonPrice && oneTimePrice) buttonPrice.textContent = oneTimePrice;
          } else if (pairedProducts) {
            if (currentPrice) currentPrice.textContent = root.dataset.subscriptionPrice;
            if (buttonPrice) buttonPrice.textContent = root.dataset.subscriptionPrice;
          } else {
            const activePlan = root.querySelector('[data-plan-option]:checked');
            if (!pairedProducts && buttonPrice && activePlan) buttonPrice.textContent = activePlan.dataset.planPrice;
          }
          if (error) error.hidden = true;
        });
      });

      const syncConfiguredDiscount = async (code, shouldApply) => {
        const routeRoot = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${routeRoot}cart.js`, {
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!cartResponse.ok) throw new Error('Unable to read cart discounts.');

        const cart = await cartResponse.json();
        const existingDiscountCodes = (cart.discount_codes || []).map((discount) => discount.code).filter(Boolean);
        const discountCodes = existingDiscountCodes.filter((discountCode) => discountCode.toLowerCase() !== code.toLowerCase());
        if (shouldApply) {
          discountCodes.push(code);
        }
        if (discountCodes.length === existingDiscountCodes.length && discountCodes.every((discountCode, index) => discountCode === existingDiscountCodes[index])) {
          return cart;
        }

        const updateResponse = await fetch(`${routeRoot}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ discount: discountCodes.join(',') })
        });
        const updatedCart = await updateResponse.json().catch(() => ({}));
        if (!updateResponse.ok) throw new Error(updatedCart.description || updatedCart.message || 'Unable to apply discount code.');

        const configuredDiscount = (updatedCart.discount_codes || []).find((discount) => discount.code?.toLowerCase() === code.toLowerCase());
        if (shouldApply && (!configuredDiscount || configuredDiscount.applicable === false)) {
          throw new Error('The configured discount code is not applicable to this cart.');
        }
        if (!shouldApply && configuredDiscount) throw new Error('Unable to remove the subscription discount from this cart.');
        return updatedCart;
      };

      if (form) {
        form.addEventListener('submit', async (event) => {
          const subscription = root.querySelector('[data-purchase-option]:checked')?.value === 'subscription';
          if (subscription && terms && !terms.checked) {
            event.preventDefault();
            error.hidden = false;
            terms.focus();
            return;
          }
          event.preventDefault();
          const submit = root.querySelector('[data-add-to-cart]');
          const mainVariantId = Number(variantInput?.value);
          const subscriptionVariantId = pairedProducts ? Number(root.dataset.subscriptionVariantId) : mainVariantId;
          const sellingPlanId = Number(sellingPlanInput?.value);
          if (!mainVariantId || (subscription && (!subscriptionVariantId || !sellingPlanId))) {
            if (error) {
              error.textContent = 'The selected subscription option is unavailable. Please refresh and try again.';
              error.hidden = false;
            }
            return;
          }

          root.dataset.submitting = 'true';
          if (submit) submit.disabled = true;
          if (error) error.hidden = true;
          try {
            if (subscription && limitSubscriptionQuantity) {
              const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
                cache: 'no-store',
                headers: { Accept: 'application/json' }
              });
              if (!cartResponse.ok) throw new Error('Unable to check the cart. Please refresh and try again.');
              const cart = await cartResponse.json();
              const existingSubscription = cart.items?.some((item) => {
                const properties = item.properties || {};
                const matchingVariant = Number(item.variant_id) === subscriptionVariantId;
                const subscriptionLine = properties[limitedSubscriptionProperty] === 'true' || properties._subscription_pair_role === 'subscription';
                return matchingVariant && subscriptionLine && Boolean(item.selling_plan_allocation);
              });
              if (existingSubscription) throw new Error(duplicateSubscriptionMessage);
            }

            if (!subscription && configuredDiscountCode) {
              try {
                await syncConfiguredDiscount(configuredDiscountCode, false);
              } catch (discountError) {
                form.dispatchEvent(new CustomEvent('product:discount-error', {
                  bubbles: true,
                  detail: { error: discountError, code: configuredDiscountCode }
                }));
                if (error) {
                  error.textContent = 'Unable to remove the subscription discount. Please refresh and try again.';
                  error.hidden = false;
                }
                return;
              }
            }

            const pairId = `ulike-subscription-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
            const subscriptionProperties = pairedProducts
              ? { _subscription_pair_id: pairId, _subscription_pair_role: 'subscription' }
              : {};
            if (limitSubscriptionQuantity) subscriptionProperties[limitedSubscriptionProperty] = 'true';
            let items;
            if (pairedProducts && subscription) {
              items = [
                  {
                    id: mainVariantId,
                    quantity: 1,
                    properties: { _subscription_pair_id: pairId, _subscription_pair_role: 'main' }
                  },
                  {
                    id: subscriptionVariantId,
                    quantity: 1,
                    selling_plan: sellingPlanId,
                    properties: subscriptionProperties
                  }
                ];
            } else if (subscription) {
              items = [{ id: mainVariantId, quantity: 1, selling_plan: sellingPlanId, properties: subscriptionProperties }];
            } else {
              items = [{ id: mainVariantId, quantity: 1 }];
            }

            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items, sections: ['mini-cart'], sections_url: window.location.pathname })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this plan to cart.');

            if (subscription && configuredDiscountCode) {
              try {
                await syncConfiguredDiscount(configuredDiscountCode, true);
              } catch (discountError) {
                form.dispatchEvent(new CustomEvent('product:discount-error', {
                  bubbles: true,
                  detail: { error: discountError, code: configuredDiscountCode }
                }));
              }
            }

            const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
            const cart = await cartResponse.json();
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart, sections: result.sections, openMiniCart: true }
            }));
          } catch (submitError) {
            if (error) {
              error.textContent = submitError.message;
              error.hidden = false;
            }
          } finally {
            root.dataset.submitting = 'false';
            syncSubmitAvailability();
          }
        });
      }

      const dialog = root.querySelector('[data-consult-dialog]');
      root.querySelector('[data-upsello-open]')?.addEventListener('click', () => {
        const detail = {
          product: root.dataset.productTitle,
          productHandle: root.dataset.productHandle,
          plan: root.dataset.planTitle,
          variantId: variantInput?.value,
          sellingPlanId: sellingPlanInput?.disabled ? null : sellingPlanInput?.value
        };
        window.dispatchEvent(new CustomEvent('upsello:open', { detail }));
        if (window.Upsello && typeof window.Upsello.open === 'function') {
          window.Upsello.open(detail);
          return;
        }
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });
      root.querySelector('[data-consult-close]')?.addEventListener('click', () => dialog?.close());
    });
    if (document.documentElement.dataset.subscriptionAddReady !== 'true') {
      document.documentElement.dataset.subscriptionAddReady = 'true';
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-subscription-add]');
        if (!trigger) return;
        const purchaseRoot = document.querySelector('[data-subscription-purchase]');
        const purchaseForm = purchaseRoot?.querySelector('[data-product-form]');
        const submitButton = purchaseRoot?.querySelector('[data-add-to-cart]');
        if (!purchaseForm || !submitButton) return;
        event.preventDefault();
        if (submitButton.disabled) return;
        purchaseForm.requestSubmit(submitButton);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-air-series-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-air-comparison')) customElements.define('ulike-air-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.selects = [...this.querySelectorAll('[data-compare-select]')];
      if (this.selects[0]?.options.length >= 2) {
        this.selects[0].selectedIndex = 0; this.selects[1].selectedIndex = 1;
        this.querySelector('[data-selectors]').hidden = false;
        this.selects.forEach((select, index) => select.addEventListener('change', () => {
          const other = this.selects[1 - index];
          if (other.value === select.value) other.value = [...other.options].find(option => option.value !== select.value).value;
          this.updateColumns();
        }, { signal: this.controller.signal }));
        this.updateColumns();
      }
      this.querySelectorAll('[data-variant-control]').forEach(control => { control.hidden = false; });
      this.querySelectorAll('[data-variant-swatches]').forEach(swatches => { swatches.hidden = false; });
      this.querySelectorAll('[data-variant-choice]').forEach(choice => choice.addEventListener('click', () => {
        const select = choice.closest('[data-device]').querySelector('[data-variant]');
        select.value = choice.dataset.variantChoice;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal: this.controller.signal }));
      this.querySelectorAll('[data-variant]').forEach(select => select.addEventListener('change', () => {
        const option = select.selectedOptions[0], card = select.closest('[data-device]');
        card.querySelectorAll('[data-variant-choice]').forEach(choice => { choice.setAttribute('aria-pressed', String(choice.dataset.variantChoice === option.value)); });
        card.querySelector('[data-price]').textContent = option.dataset.price;
        const image = card.querySelector('.air-series__device-image');
        if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
        const link = card.querySelector('[data-buy]'), url = new URL(link.href); url.searchParams.set('variant', option.value); link.href = url.href;
      }, { signal: this.controller.signal }));
      this.dataset.ready = 'true';
    }
    updateColumns() {
      const selected = this.selects.map(select => select.value);
      this.querySelectorAll('[data-column]').forEach(cell => {
        cell.hidden = !selected.includes(cell.dataset.column);
        delete cell.dataset.comparePosition;
      });
      this.querySelectorAll('tr').forEach(row => selected.forEach((value, index) => {
        const cell = row.querySelector(`[data-column="${value}"]`);
        if (cell) {
          cell.dataset.comparePosition = String(index + 1);
          row.appendChild(cell);
        }
      }));
    }
    disconnectedCallback() { this.controller?.abort(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-article-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-article-recommendations')) {
    customElements.define('ulike-article-recommendations', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('.uar-track');
        const controls = this.querySelector('.uar-controls');
        if (!track || !controls) return;
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const {signal} = this.controller;
        const previous = controls.querySelector('[data-direction="-1"]');
        const next = controls.querySelector('[data-direction="1"]');
        const update = () => {
          const extent = track.scrollWidth - track.clientWidth;
          controls.hidden = extent < 2;
          previous.disabled = Math.abs(track.scrollLeft) < 2;
          next.disabled = Math.abs(track.scrollLeft) >= extent - 2;
        };
        controls.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || button.disabled) return;
          const card = track.querySelector('.uar-card');
          const style = getComputedStyle(track);
          const step = (card?.getBoundingClientRect().width || track.clientWidth) + parseFloat(style.columnGap || 0);
          track.scrollBy({left: step * Number(button.dataset.direction) * (style.direction === 'rtl' ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }, {signal});
        track.addEventListener('scroll', update, {passive: true, signal});
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-blog-index"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-blog-index')) {
    customElements.define('ulike-blog-index', class extends HTMLElement {
      connectedCallback() {
        const close = this.querySelector('.ubi-close');
        if (!close || close.dataset.ready) return;
        close.dataset.ready = 'true';
        close.hidden = false;
        close.addEventListener('click', () => {
          close.closest('aside').hidden = true;
          this.querySelector('.ubi-hero-link')?.focus({preventScroll: true});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-campaign-offer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-campaign-offer]').forEach((offer) => {
    const timer = offer.querySelector('[data-campaign-offer-timer]');
    const end = new Date(offer.dataset.endDate);
    if (Number.isNaN(end.getTime())) return;
    const render = () => {
      const remaining = end.getTime() - Date.now();
      if (remaining <= 0) { timer.textContent = 'Offer ended'; return; }
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      timer.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    };
    render(); window.setInterval(render, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-collection-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-collection-results')) customElements.define('ulike-collection-results', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.area = this.querySelector('[data-result-area]'); this.filters = [...this.querySelectorAll('[data-result-filter]')];
      this.cards = [...this.querySelectorAll('[data-result]')]; this.more = this.querySelector('[data-results-more]'); this.empty = this.querySelector('[data-results-empty]'); this.limit = 3;
      this.querySelector('[data-results-controls]').hidden = false;
      const options = { signal: this.controller.signal };
      [this.area, ...this.filters].forEach(input => input.addEventListener('change', () => { this.limit = 3; this.update(); }, options));
      this.querySelector('[data-results-clear]').addEventListener('click', () => { this.filters.forEach(input => { input.checked = false; }); this.limit = 3; this.update(); }, options);
      this.more.addEventListener('click', () => { this.limit += 3; this.update(); }, options);
      this.update();
    }
    update() {
      const selected = Object.fromEntries(['product','cycle','tone'].map(name => [name,this.filters.filter(input => input.dataset.resultFilter === name && input.checked).map(input => input.value)]));
      let matched = 0;
      for (const card of this.cards) {
        const matches = card.dataset.area === this.area.value && Object.entries(selected).every(([key,values]) => !values.length || values.includes(card.dataset[key]));
        const hidden = !matches || ++matched > this.limit;
        if (hidden) card.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); });
        card.hidden = hidden;
      }
      this.more.hidden = matched <= this.limit; this.empty.hidden = matched !== 0;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-compatibility-checker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-compatibility-checker')) {
    customElements.define('ulike-compatibility-checker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('[data-dialog]');
        this.groups = Array.from(this.querySelectorAll('[data-option-group]'));
        this.submitButton = this.querySelector('[data-submit]');
        this.formView = this.querySelector('[data-form-view]');
        this.resultView = this.querySelector('[data-result-view]');
        this.triggerSelector = `[data-compatibility-trigger="${CSS.escape(this.dataset.dialogId)}"]`;
        document.querySelectorAll(this.triggerSelector).forEach((trigger) => trigger.addEventListener('click', () => this.open(trigger)));
        this.querySelector('[data-close]')?.addEventListener('click', () => this.close());
        this.querySelector('[data-shop]')?.addEventListener('click', () => this.close(false));
        this.querySelector('[data-reset]')?.addEventListener('click', () => this.reset(true));
        this.querySelectorAll('[data-option]').forEach((option) => option.addEventListener('click', () => this.select(option)));
        this.submitButton?.addEventListener('click', () => this.showResult());
        this.dialog?.addEventListener('click', (event) => { if (event.target === this.dialog) this.close(); });
        this.dialog?.addEventListener('close', () => { this.restoreFocus(); this.reset(false); });
      }

      open(trigger) {
        if (!this.dialog) return;
        this.trigger = trigger;
        this.dialog.showModal();
        this.querySelector('[data-close]')?.focus();
      }

      close(restoreFocus = true) {
        if (!this.dialog?.open) return;
        if (!restoreFocus) this.trigger = null;
        this.dialog.close();
      }

      restoreFocus() {
        this.trigger?.focus();
        this.trigger = null;
      }

      select(option) {
        const group = option.closest('[data-option-group]');
        group?.querySelectorAll('[data-option]').forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
        this.submitButton.disabled = this.groups.some((item) => !item.querySelector('[data-option][aria-pressed="true"]'));
      }

      showResult() {
        const selected = this.groups.map((group) => group.querySelector('[data-option][aria-pressed="true"]'));
        if (selected.some((option) => !option)) return;
        const compatible = selected.every((option) => option.dataset.compatible === 'true');
        this.querySelectorAll('[data-result]').forEach((panel) => { panel.hidden = panel.dataset.result !== (compatible ? 'positive' : 'negative'); });
        this.formView.hidden = true;
        this.resultView.hidden = false;
        this.resultView.querySelector('[data-result]:not([hidden]) .heading')?.focus();
      }

      reset(focusFirst) {
        this.querySelectorAll('[data-option]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.querySelectorAll('[data-result]').forEach((panel) => { panel.hidden = true; });
        this.formView.hidden = false;
        this.resultView.hidden = true;
        this.submitButton.disabled = true;
        if (focusFirst) this.querySelector('[data-option]')?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-compatibility-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-compatibility-guide')) {
    customElements.define('ulike-compatibility-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.groups = Array.from(this.querySelectorAll('[data-option-group]'));
        this.results = Array.from(this.querySelectorAll('[data-result]'));
        this.liveStatus = this.querySelector('[data-live-status]');
        this.querySelectorAll('[data-option]').forEach((option) => option.addEventListener('click', () => this.select(option)));
        this.querySelectorAll('[data-reset]').forEach((button) => button.addEventListener('click', () => this.reset()));
      }

      select(option) {
        if (this.completed) return;
        const group = option.closest('[data-option-group]');
        group.querySelectorAll('[data-option]').forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
        this.update();
      }

      update() {
        const selected = this.groups.map((group) => group.querySelector('[data-option][aria-pressed="true"]'));
        if (selected.some((option) => !option)) return;
        this.completed = true;
        this.querySelectorAll('[data-option]').forEach((option) => { option.disabled = true; });
        let result = 'success';
        if (selected[0].dataset.compatible !== 'true') result = 'skin-error';
        else if (selected[1].dataset.compatible !== 'true') result = 'hair-error';
        this.results.forEach((panel) => { panel.hidden = panel.dataset.result !== result; });
        const visiblePanel = this.results.find((panel) => panel.dataset.result === result);
        if (this.liveStatus && visiblePanel) this.liveStatus.textContent = visiblePanel.textContent.trim();
      }

      reset() {
        this.completed = false;
        this.querySelectorAll('[data-option]').forEach((item) => {
          item.disabled = false;
          item.setAttribute('aria-pressed', 'false');
        });
        this.results.forEach((panel) => { panel.hidden = true; });
        if (this.liveStatus) this.liveStatus.textContent = '';
        this.querySelector('[data-option]')?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-contact-hub"] && !Shopify.designMode) return;
  try {
    
  if (document.documentElement.dataset.ulikeContactChatBound !== 'true') {
    document.documentElement.dataset.ulikeContactChatBound = 'true';
    document.addEventListener('click', event => {
      const chatLink = event.target.closest('[data-ulike-contact-chat]');
      if (!chatLink) return;
      if (!window.quickChatApi || typeof window.quickChatApi.chat !== 'function') return;
      event.preventDefault();
      window.quickChatApi.chat();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-cp-before-after"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ulike-compare]').forEach((root)=>{if(root.dataset.ready)return;root.dataset.ready='true';const setPosition=(value)=>root.style.setProperty('--compare-position',`${value}%`);root.querySelectorAll('[data-compare-range]').forEach((range)=>range.addEventListener('input',()=>setPosition(range.value)));root.querySelectorAll('[data-compare-tab]').forEach((tab)=>tab.addEventListener('click',()=>{const id=tab.dataset.compareTab;root.querySelectorAll('[data-compare-tab]').forEach((item)=>{const active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',String(active))});root.querySelectorAll('[data-compare-panel]').forEach((panel)=>panel.hidden=panel.dataset.comparePanel!==id)}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-cp-buy-box"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ulike-buy-box]').forEach((root)=>{if(root.dataset.ready)return;root.dataset.ready='true';const main=root.querySelector('.ulike-buybox__main-image');root.querySelectorAll('[data-gallery-thumb]').forEach((thumb)=>thumb.addEventListener('click',()=>{if(main){main.src=thumb.dataset.imageSrc;main.removeAttribute('srcset')}root.querySelectorAll('[data-gallery-thumb]').forEach((item)=>{item.classList.toggle('is-active',item===thumb);item.setAttribute('aria-pressed',String(item===thumb))})}));const variantInput=root.querySelector('[data-variant-input]');const planInput=root.querySelector('[data-selling-plan-input]');const price=root.querySelector('[data-current-price]');const addPrice=root.querySelector('[data-add-price]');const oneTimePrice=root.querySelector('[data-one-time-card-price]');const planCardPrice=root.querySelector('[data-plan-card-price]');const details=root.querySelector('[data-plan-details]');let mode=root.querySelector('[data-purchase-choice="plan"]')?'plan':'one-time';const setPrice=(value)=>{if(price)price.textContent=value;if(addPrice)addPrice.textContent=value};const choosePlan=(button)=>{if(!button)return;if(planInput){planInput.name='selling_plan';planInput.disabled=false;planInput.value=button.dataset.planId}button.closest('[data-plan-panel]')?.querySelectorAll('[data-plan-choice]').forEach((item)=>{item.classList.toggle('is-active',item===button);item.setAttribute('aria-pressed',String(item===button))});if(planCardPrice)planCardPrice.textContent=button.dataset.planPrice;setPrice(button.dataset.planPrice)};const updateMode=(next)=>{mode=next;root.querySelectorAll('[data-purchase-choice]').forEach((item)=>{const active=item.dataset.purchaseChoice===next;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',String(active))});if(details)details.hidden=next!=='plan';if(next==='plan'){const panel=root.querySelector('[data-plan-panel]:not([hidden])');choosePlan(panel?.querySelector('[data-plan-choice].is-active')||panel?.querySelector('[data-plan-choice]'))}else{if(planInput){planInput.disabled=true;planInput.removeAttribute('name');planInput.value=''}const active=root.querySelector('[data-variant-choice].is-active');setPrice(active?.dataset.price||oneTimePrice?.textContent||'')}};root.querySelectorAll('[data-purchase-choice]').forEach((button)=>button.addEventListener('click',()=>updateMode(button.dataset.purchaseChoice)));root.querySelectorAll('[data-plan-choice]').forEach((button)=>button.addEventListener('click',()=>choosePlan(button)));root.querySelectorAll('[data-variant-choice]').forEach((button)=>button.addEventListener('click',()=>{root.querySelectorAll('[data-variant-choice]').forEach((item)=>{item.classList.toggle('is-active',item===button);item.setAttribute('aria-pressed',String(item===button))});if(variantInput)variantInput.value=button.dataset.variantId;if(oneTimePrice)oneTimePrice.textContent=button.dataset.price;root.querySelectorAll('[data-plan-panel]').forEach((panel)=>panel.hidden=panel.dataset.planPanel!==button.dataset.variantId);updateMode(mode)}));updateMode(mode)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-device-comparison"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    const scroller = event.target.closest('[data-device-comparison-scroll]');
    if (!scroller || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    if (scroller.scrollWidth <= scroller.clientWidth) return;
    event.preventDefault();
    const direction = event.key === 'ArrowLeft' ? -1 : 1;
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    scroller.scrollBy({ left: direction * Math.max(240, scroller.clientWidth * 0.75), behavior });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-expert-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-expert-carousel')) {
    class UlikeExpertCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        new ResizeObserver(() => this.update()).observe(this.viewport);
        this.update();
      }

      move(direction) {
        const card = this.viewport.querySelector('.ulike-experts__card');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(this.viewport.querySelector('.ulike-experts__track')).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-expert-carousel', UlikeExpertCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-gift-compatibility"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-gift-compatibility')) {
    customElements.define('ulike-gift-compatibility', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.groups = Array.from(this.querySelectorAll('[data-option-group]'));
        this.results = Array.from(this.querySelectorAll('[data-result]'));
        this.liveStatus = this.querySelector('[data-live-status]');
        this.querySelectorAll('[data-option]').forEach((option) => option.addEventListener('click', () => this.select(option)));
        this.querySelectorAll('[data-reset]').forEach((button) => button.addEventListener('click', () => this.reset()));
      }

      select(option) {
        const group = option.closest('[data-option-group]');
        group.querySelectorAll('[data-option]').forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
        this.update();
      }

      update() {
        const selected = this.groups.map((group) => group.querySelector('[data-option][aria-pressed="true"]'));
        if (selected.some((option) => !option)) return;
        let result = 'success';
        if (selected[1].dataset.compatible !== 'true') result = 'hair-error';
        else if (selected[0].dataset.compatible !== 'true') result = 'skin-error';
        this.results.forEach((panel) => { panel.hidden = panel.dataset.result !== result; });
        const visiblePanel = this.results.find((panel) => panel.dataset.result === result);
        if (this.liveStatus && visiblePanel) this.liveStatus.textContent = visiblePanel.textContent.trim();
      }

      reset() {
        this.querySelectorAll('[data-option]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.results.forEach((panel) => { panel.hidden = true; });
        if (this.liveStatus) this.liveStatus.textContent = '';
        this.querySelector('[data-option]')?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-gift-technology"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-gift-technology')) {
    customElements.define('ulike-gift-technology', class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-scroller]');
        if (!this.scroller) return;
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.scroller.addEventListener('scroll', () => this.updateControls(), { passive: true });
        new ResizeObserver(() => this.updateControls()).observe(this.scroller);
        this.updateControls();
      }

      move(direction) {
        const card = this.scroller.querySelector('.ulike-gift-technology__video-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.scroller).columnGap) || 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scroller.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      updateControls() {
        const maximum = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const position = Math.abs(this.scroller.scrollLeft);
        if (this.previousButton) this.previousButton.disabled = position <= 2;
        if (this.nextButton) this.nextButton.disabled = position >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-help-contact"] && !Shopify.designMode) return;
  try {
    
  if (document.documentElement.dataset.ulikeHelpChatBound !== 'true') {
    document.documentElement.dataset.ulikeHelpChatBound = 'true';
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-ulike-help-chat]');
      if (!link || !window.quickChatApi || typeof window.quickChatApi.chat !== 'function') return;
      event.preventDefault();
      window.quickChatApi.chat();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-help-faq"] && !Shopify.designMode) return;
  try {
    
  const bindHelpFaq = root => {
    if (!root || root.dataset.helpFaqBound === 'true') return;
    root.dataset.helpFaqBound = 'true';
    const tabs = [...root.querySelectorAll('[data-help-tab]')];
    const selectTab = selectedTab => {
      tabs.forEach(item => {
        const active = item === selectedTab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        const panel = root.querySelector(`#${CSS.escape(item.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !active;
      });
    };
    tabs.forEach(tab => tab.addEventListener('click', () => selectTab(tab)));
    selectTab(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
  };
  document.querySelectorAll('[data-ulike-help-faq]').forEach(bindHelpFaq);
  document.addEventListener('shopify:section:load', event => bindHelpFaq(event.target.querySelector('[data-ulike-help-faq]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-home-expert-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-expert-scroller')) {
    customElements.define('ulike-expert-scroller', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-track]');
        this.previousButtons = this.querySelectorAll('[data-previous]');
        this.nextButtons = this.querySelectorAll('[data-next]');
        if (!this.track) return;
        this.previousButtons.forEach((button) => button.addEventListener('click', () => this.move(-1), options));
        this.nextButtons.forEach((button) => button.addEventListener('click', () => this.move(1), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.track.scrollTo({ left: 0, behavior: 'auto' });
          else if (event.key === 'End') this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'auto' });
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      move(direction) {
        const slide = this.track.querySelector('[data-slide]');
        if (!slide) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior });
      }
      update() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const start = this.track.scrollLeft <= 2;
        const end = this.track.scrollLeft >= max - 2;
        this.previousButtons.forEach((button) => { button.disabled = start; });
        this.nextButtons.forEach((button) => { button.disabled = end; });
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-home-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-feature-showcase')) {
    customElements.define('ulike-feature-showcase', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('.ulike-feature-showcase__item')];
        this.videos = [...this.querySelectorAll('[data-deferred-video]')];
        this.visibleVideos = new Set();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.carousel = this.hasAttribute('data-carousel') && this.slides.length > 1;
        this.activeIndex = 0;
        this.prev = this.querySelector('[data-feature-prev]');
        this.next = this.querySelector('[data-feature-next]');
        this.status = this.querySelector('[data-feature-status]');
        if (this.carousel) {
          this.prev.addEventListener('click', () => this.select(this.activeIndex - 1), options);
          this.next.addEventListener('click', () => this.select(this.activeIndex + 1), options);
          this.addEventListener('keydown', (event) => {
            if (event.target !== this.prev && event.target !== this.next) return;
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1);
            this.select(index);
          }, options);
          const stage = this.querySelector('.ulike-feature-showcase__list');
          stage.addEventListener('touchstart', (event) => {
            this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY, time: Date.now() } : null;
          }, { ...options, passive: true });
          stage.addEventListener('touchcancel', () => { this.touch = null; }, options);
          stage.addEventListener('touchend', (event) => {
            const start = this.touch;
            this.touch = null;
            if (!start || !event.changedTouches.length || event.touches.length) return;
            const dx = event.changedTouches[0].clientX - start.x;
            const dy = event.changedTouches[0].clientY - start.y;
            if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.2 || Date.now() - start.time > 800) return;
            this.select(this.activeIndex + (dx < 0 ? 1 : -1));
          }, { ...options, passive: true });
          stage.addEventListener('ulike:drag-switch', (event) => {
            this.select(this.activeIndex + event.detail.direction);
          }, options);
          this.addEventListener('shopify:block:select', (event) => {
            const index = this.slides.indexOf(event.target.closest('.ulike-feature-showcase__item'));
            if (index >= 0) this.select(index);
          }, options);
          this.setAttribute('data-enhanced', '');
          this.querySelector('.ulike-feature-showcase__navigation').hidden = false;
          this.select(0);
        }
        document.addEventListener('visibilitychange', () => this.updateVideos(), options);
        this.motion.addEventListener('change', () => this.updateVideos(), options);
        navigator.connection?.addEventListener('change', () => this.updateVideos(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach(({ target, isIntersecting }) => {
              if (isIntersecting) this.visibleVideos.add(target);
              else this.visibleVideos.delete(target);
            });
            this.updateVideos();
          });
          this.videos.forEach((video) => this.observer.observe(video));
        } else {
          this.videos.forEach((video) => { video.controls = true; });
        }
      }

      select(index) {
        this.activeIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        this.slides.forEach((slide, i) => {
          slide.setAttribute('aria-hidden', String(i !== this.activeIndex));
          slide.inert = i !== this.activeIndex;
        });
        this.prev.disabled = this.activeIndex === 0;
        this.next.disabled = this.activeIndex === this.slides.length - 1;
        this.status.textContent = `${this.activeIndex + 1} / ${this.slides.length}`;
        if (document.activeElement === this.prev && this.prev.disabled) this.next.focus();
        if (document.activeElement === this.next && this.next.disabled) this.prev.focus();
        this.updateVideos();
      }

      updateVideos() {
        this.videos.forEach((video) => {
          const active = !this.carousel || this.slides[this.activeIndex].contains(video);
          if (!active || !this.visibleVideos.has(video) || document.hidden || this.motion.matches || navigator.connection?.saveData) {
            video.pause();
            return;
          }
          const sources = [...video.querySelectorAll('source[data-src]')];
          sources.forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          if (sources.length) video.load();
          video.play().catch(() => {});
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.videos?.forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-home-journal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-journal-scroller')) {
    customElements.define('ulike-journal-scroller', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.track = this.querySelector('[data-track]');
        this.previousButtons = this.querySelectorAll('[data-previous]');
        this.nextButtons = this.querySelectorAll('[data-next]');
        if (!this.track) return;

        const options = { signal: this.controller.signal };
        this.previousButtons.forEach((button) => button.addEventListener('click', () => this.move(-1), options));
        this.nextButtons.forEach((button) => button.addEventListener('click', () => this.move(1), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') {
            this.track.scrollTo({ left: 0, behavior: 'auto' });
          } else if (event.key === 'End') {
            this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'auto' });
          } else {
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.track);
        }
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      move(direction) {
        const slide = this.track?.querySelector('[data-slide]');
        if (!slide) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        if (!this.track) return;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const start = this.track.scrollLeft <= 2;
        const end = this.track.scrollLeft >= max - 2;
        this.previousButtons.forEach((button) => { button.disabled = start; });
        this.nextButtons.forEach((button) => { button.disabled = end; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-home-lifestyle-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-lifestyle-tabs')) {
    customElements.define('ulike-lifestyle-tabs', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.slides = [...this.querySelectorAll('[role="tabpanel"]')];
        this.descriptions = [...this.querySelectorAll('[data-description]')];
        this.index = 0;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(next); this.tabs[next].focus({ preventScroll: true });
          }, options);
        });
        const images = this.querySelector('[data-images]');
        images.addEventListener('touchstart', event => { this.touch = event.touches[0]; }, { ...options, passive: true });
        images.addEventListener('touchend', event => {
          if (!this.touch || !event.changedTouches.length) return;
          const end = event.changedTouches[0], dx = end.clientX - this.touch.clientX, dy = end.clientY - this.touch.clientY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) this.select((this.index + (dx < 0 ? 1 : -1) + this.tabs.length) % this.tabs.length);
          this.touch = null;
        }, { ...options, passive: true });
        images.addEventListener('ulike:drag-switch', event => {
          this.select((this.index + event.detail.direction + this.tabs.length) % this.tabs.length);
        }, options);
        this.addEventListener('shopify:block:select', event => { const index = this.slides.indexOf(event.target.closest('[role="tabpanel"]')); if (index >= 0) this.select(index); }, options);
        document.addEventListener('visibilitychange', () => {
          clearTimeout(this.autoplayTimer);
          if (!document.hidden) this.schedule();
        }, options);
        this.select(0, false);
      }
      schedule(transition = 0) {
        clearTimeout(this.autoplayTimer);
        if (this.tabs.length > 1 && !document.hidden) {
          this.autoplayTimer = setTimeout(() => this.select((this.index + 1) % this.tabs.length), 5000 + transition);
        }
      }
      stop() {
        clearTimeout(this.autoplayTimer);
        clearTimeout(this.transitionTimer);
        this.animations?.forEach(animation => animation.cancel());
      }
      select(index, animate = true) {
        const previous = this.index;
        this.stop();
        const duration = animate && previous !== index && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 800 : 0;
        this.index = index;
        this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; this.slides[i].hidden = i !== index; this.descriptions[i].hidden = i !== index; });
        if (duration) {
          const outgoing = this.slides[previous], incoming = this.slides[index];
          const direction = index === (previous + 1) % this.tabs.length ? 1 : -1;
          outgoing.hidden = false;
          this.animations = [
            outgoing.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${-direction * 100}%)` }], { duration, easing: 'ease', fill: 'forwards' }),
            incoming.animate([{ transform: `translateX(${direction * 100}%)` }, { transform: 'translateX(0)' }], { duration, easing: 'ease', fill: 'forwards' })
          ];
          this.transitionTimer = setTimeout(() => { outgoing.hidden = true; this.animations.forEach(animation => animation.cancel()); }, duration);
        }
        const tab = this.tabs[index], list = tab.parentElement;
        if (list.scrollWidth > list.clientWidth) list.scrollTo({ left: tab.offsetLeft - list.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2, behavior: 'auto' });
        this.schedule(duration);
      }
      disconnectedCallback() { this.stop(); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-home-media-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-responsive-media-hero')) {
    customElements.define('ulike-responsive-media-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.mobile = matchMedia('(max-width: 740px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.isFirstSection = this.hasAttribute('data-first-section');
        this.visible = this.isFirstSection;

        this.onPlaying = () => this.setAttribute('data-video-playing', '');
        this.onVideoFailure = () => this.removeAttribute('data-video-playing');

        this.getSourceTemplate = () => {
          const requestedDevice = this.mobile.matches ? 'mobile' : 'desktop';
          return this.querySelector(`template[data-video-sources="${requestedDevice}"]`)
            || this.querySelector('template[data-video-sources="desktop"]')
            || this.querySelector('template[data-video-sources="mobile"]');
        };

        this.loadSelectedVideo = () => {
          const template = this.getSourceTemplate();
          if (!template) return false;

          const sourceData = [...template.content.querySelectorAll('source[data-src]')];
          const sourceKey = sourceData.map(source => `${source.dataset.src}|${source.type}`).join(',');
          if (!sourceKey) return false;
          if (sourceKey === this.activeSourceKey) return true;

          this.video.pause();
          this.removeAttribute('data-video-playing');
          this.video.replaceChildren(...sourceData.map(sourceDataItem => {
            const source = document.createElement('source');
            source.src = sourceDataItem.dataset.src;
            if (sourceDataItem.type) source.type = sourceDataItem.type;
            return source;
          }));
          this.activeSourceKey = sourceKey;
          this.video.load();
          return true;
        };

        this.update = () => {
          const shouldLoad = this.isFirstSection || this.visible;
          const allowed = shouldLoad && !document.hidden && !this.motion.matches && !navigator.connection?.saveData;
          if (!allowed) { this.video.pause(); return; }
          if (!this.loadSelectedVideo()) return;
          this.video.play().catch(this.onVideoFailure);
        };

        this.onBreakpointChange = () => {
          this.update();
        };

        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('error', this.onVideoFailure);
        this.mobile.addEventListener('change', this.onBreakpointChange);
        this.motion.addEventListener('change', this.update);
        document.addEventListener('visibilitychange', this.update);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.update();
        });
        this.observer.observe(this);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
        if (!this.update) return;
        this.video.removeEventListener('playing', this.onPlaying);
        this.video.removeEventListener('error', this.onVideoFailure);
        this.mobile.removeEventListener('change', this.onBreakpointChange);
        this.motion.removeEventListener('change', this.update);
        document.removeEventListener('visibilitychange', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-home-results-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-results-tabs')) {
    customElements.define('ulike-results-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('.ulike-results-tabs__panel'));
        this.indicator = this.querySelector('.ulike-results-tabs__indicator');
        if (!this.tabs.length) return;
        this.currentIndex = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
        this.querySelector('[data-ulike-drag-switch]')?.addEventListener('ulike:drag-switch', (event) => {
          const current = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
          this.select(Math.max(0, Math.min(current + event.detail.direction, this.tabs.length - 1)));
        });
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          this.inViewport = entries[0].isIntersecting;
          if (this.inViewport) this.activateVideo(this.panelFor(this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true')));
          else this.querySelectorAll('video').forEach(video => video.pause());
        });
        this.observer.observe(this);
        this.updateIndicator(this.currentIndex, false);
        requestAnimationFrame(() => requestAnimationFrame(() => this.updateIndicator(this.currentIndex, false)));
        this.onResize = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.updateIndicator(this.currentIndex, false), 100);
        };
        window.addEventListener('resize', this.onResize);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        clearTimeout(this.switchTimer);
        clearTimeout(this.resizeTimer);
        window.removeEventListener('resize', this.onResize);
        this.querySelectorAll('video').forEach(video => video.pause());
      }

      panelFor(tab) {
        return tab ? this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`) : null;
      }

      updateIndicator(index, animate = true) {
        const tab = this.tabs[index];
        if (!tab || !this.indicator) return;
        if (!animate) this.indicator.style.transition = 'none';
        this.indicator.style.width = `${tab.offsetWidth}px`;
        this.indicator.style.transform = `translate3d(${tab.offsetLeft}px, 0, 0)`;
        if (!animate) {
          void this.indicator.offsetWidth;
          this.indicator.style.removeProperty('transition');
        }
      }

      select(index, animate = true) {
        if (!this.tabs[index] || !this.panels[index]) return;
        const previousIndex = this.currentIndex;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
        });
        this.updateIndicator(index, animate);
        if (index === previousIndex) {
          this.activateVideo(this.panels[index]);
          return;
        }
        clearTimeout(this.switchTimer);
        this.currentIndex = index;
        const nextPanel = this.panels[index];
        nextPanel.classList.add('is-active');
        nextPanel.setAttribute('aria-hidden', 'false');
        this.activateVideo(nextPanel);
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 550;
        this.switchTimer = setTimeout(() => {
          this.panels.forEach((panel, panelIndex) => {
            if (panelIndex === this.currentIndex) return;
            panel.classList.remove('is-active');
            panel.setAttribute('aria-hidden', 'true');
            panel.querySelector('video')?.pause();
          });
        }, duration);
      }

      activateVideo(panel) {
        const video = panel?.querySelector('video');
        if (!video || !this.inViewport) return;
        const source = video.querySelector('source[data-src]');
        if (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          video.load();
        }
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData) video.play().catch(() => {});
      }

      onKeydown(event, index) {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-home-routine-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-routine-scroller')) {
    customElements.define('ulike-routine-scroller', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.track = this.querySelector('[data-routine-track]');
        this.previous = this.querySelector('[data-routine-previous]');
        this.next = this.querySelector('[data-routine-next]');
        if (!this.track) return;
        const options = { signal: this.controller.signal };
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.track.scrollTo({ left: 0, behavior: 'auto' });
          else if (event.key === 'End') this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'auto' });
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        if ('ResizeObserver' in window) { this.observer = new ResizeObserver(() => this.update()); this.observer.observe(this.track); }
        this.update();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
      move(direction) {
        const card = this.track?.querySelector('[data-routine-slide]');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      }
      update() {
        if (!this.track) return;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-home-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-testimonial-scroller')) {
    customElements.define('ulike-testimonial-scroller', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-track]');
        this.previousButtons = this.querySelectorAll('[data-previous]');
        this.nextButtons = this.querySelectorAll('[data-next]');
        if (!this.track) return;
        this.previousButtons.forEach((button) => button.addEventListener('click', () => this.move(-1), options));
        this.nextButtons.forEach((button) => button.addEventListener('click', () => this.move(1), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target.closest('video, audio, input, textarea, select, button, a, [contenteditable="true"]')) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.track.scrollTo({ left: 0, behavior: 'auto' });
          else if (event.key === 'End') this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'auto' });
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.track);
        }
        this.update();
      }

      move(direction) {
        const slide = this.track.querySelector('[data-slide]');
        if (!slide) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const start = this.track.scrollLeft <= 2;
        const end = this.track.scrollLeft >= max - 2;
        this.previousButtons.forEach((button) => { button.disabled = start; });
        this.nextButtons.forEach((button) => { button.disabled = end; });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-hsa-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hsa-product-grid')) {
    customElements.define('hsa-product-grid', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-hsa-variant]');
          if (!button || button.disabled || !this.contains(button)) return;
          const card = button.closest('.ulike-hsa-products__card');
          card.querySelectorAll('[data-hsa-variant]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          const input = card.querySelector('input[name="id"]');
          if (input) input.value = button.dataset.id;
          const price = card.querySelector('[data-hsa-price]');
          if (price) price.textContent = button.dataset.price;
          const images = Array.from(card.querySelectorAll('[data-hsa-image]'));
          if (images.length > 1) images.forEach((image, index) => { image.hidden = index !== Math.min(Number(button.dataset.index), images.length - 1); });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-labs-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ulike-labs-quiz]').forEach(quiz => {
    quiz.addEventListener('click', event => {
      const button = event.target.closest('[data-quiz-choice]');
      if (!button) return;
      const item = button.closest('[data-quiz-answer]');
      const correct = button.dataset.quizChoice === item.dataset.quizAnswer;
      item.querySelectorAll('[data-quiz-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
      item.querySelector('[data-quiz-status]').textContent = correct ? quiz.dataset.correctLabel : quiz.dataset.wrongLabel;
      item.classList.add('is-answered');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-labs-resources"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ulike-labs-resources]').forEach(section => {
    const dialog = section.querySelector('[data-labs-video-dialog]');
    const frame = dialog && dialog.querySelector('iframe');
    if (!dialog || !frame || typeof dialog.showModal !== 'function') return;
    section.querySelectorAll('[data-labs-video]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      frame.src = `https://www.youtube-nocookie.com/embed/${link.dataset.labsVideo}?autoplay=1&rel=0`;
      frame.title = link.getAttribute('aria-label');
      dialog.showModal();
    }));
    const close = () => { frame.src = 'about:blank'; dialog.close(); };
    dialog.querySelector('[data-labs-video-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', () => { frame.src = 'about:blank'; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-led-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.shopify-section--ulike-led-products');
    roots.forEach((root) => {
      if (root.dataset.ledProductsInitialized === 'true') return;
      const track = root.querySelector('[data-led-products-track]');
      const previous = root.querySelector('[data-led-products-previous]');
      const next = root.querySelector('[data-led-products-next]');
      if (!track || !previous || !next) return;
      root.dataset.ledProductsInitialized = 'true';
      const update = () => {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };
      const move = (direction) => track.scrollBy({ left: direction * Math.max(track.clientWidth * .8, 280), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowLeft' ? -1 : 1;
        move(getComputedStyle(track).direction === 'rtl' ? -direction : direction);
      });
      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(track);
      } else {
        window.addEventListener('resize', update, { passive: true });
      }
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-logo-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-logo-carousel')) {
    class UlikeLogoCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        new ResizeObserver(() => this.update()).observe(this.viewport);
        this.update();
      }

      move(direction) {
        const item = this.viewport.querySelector('.ulike-logo-carousel__item');
        const track = this.viewport.querySelector('.ulike-logo-carousel__track');
        if (!item || !track) return;
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-logo-carousel', UlikeLogoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-media-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-media-tabs')) {
    customElements.define('ulike-media-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = [...this.querySelectorAll('[data-media-tab]')];
        this.panels = [...this.querySelectorAll('[data-media-panel]')];
        this.previousButton = this.querySelector('[data-media-previous]');
        this.nextButton = this.querySelector('[data-media-next]');
        this.index = 0;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
        this.previousButton?.addEventListener('click', () => this.select((this.index - 1 + this.tabs.length) % this.tabs.length));
        this.nextButton?.addEventListener('click', () => this.select((this.index + 1) % this.tabs.length));
        const panels = this.querySelector('[data-media-panels]');
        panels?.addEventListener('touchstart', (event) => { this.touch = event.touches[0]; }, { passive: true });
        panels?.addEventListener('touchend', (event) => {
          if (!this.touch || !event.changedTouches.length) return;
          const end = event.changedTouches[0];
          const horizontal = end.clientX - this.touch.clientX;
          const vertical = end.clientY - this.touch.clientY;
          if (Math.abs(horizontal) > 45 && Math.abs(horizontal) > Math.abs(vertical) * 1.2) this.select((this.index + (horizontal < 0 ? 1 : -1) + this.tabs.length) % this.tabs.length);
          this.touch = null;
        }, { passive: true });
        this.select(0);
      }

      select(index, focus = false) {
        this.index = index;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
        this.tabs[index]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if (focus) this.tabs[index]?.focus();
      }

      onKeydown(event, index) {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(next, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-pcos-story"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pcos-dialog-open]').forEach((button)=>button.addEventListener('click',()=>document.getElementById(button.dataset.pcosDialogOpen).showModal()));document.querySelectorAll('[data-pcos-dialog-close]').forEach((button)=>button.addEventListener('click',()=>button.closest('dialog').close()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-power-modes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    const track = event.target.closest('[data-power-modes-track]');
    if (!track || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    if (track.scrollWidth <= track.clientWidth) return;
    event.preventDefault();
    const card = track.querySelector('.ulike-power-modes__card');
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const direction = event.key === 'ArrowLeft' ? -1 : 1;
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-press-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-press-carousel')) {
    class UlikePressCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        new ResizeObserver(() => this.update()).observe(this.viewport);
        this.update();
      }

      move(direction) {
        const card = this.viewport.querySelector('.ulike-press__card');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(this.viewport.querySelector('.ulike-press__track')).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-press-carousel', UlikePressCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-product-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-product-bundle')) {
    customElements.define('ulike-product-bundle', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-bundle-submit]');
        this.status = this.querySelector('[data-bundle-status]');
        this.onSubmit = () => this.addBundle();
        this.onVariantChange = (event) => {
          const currentItem = this.querySelector('[data-current-product]');
          if (currentItem && event.detail?.variant?.id) {
            currentItem.dataset.variantId = event.detail.variant.id;
            currentItem.dataset.available = String(event.detail.variant.available !== false);
          }
        };
        this.button?.addEventListener('click', this.onSubmit);
        document.addEventListener('variant:change', this.onVariantChange);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onSubmit);
        document.removeEventListener('variant:change', this.onVariantChange);
      }

      async addBundle() {
        const currentItem = this.querySelector('[data-current-product]');
        const selectedVariant = document.querySelector('form[id^="product-form-main-"] input[name="id"]:not([disabled])');
        if (currentItem && selectedVariant?.value) currentItem.dataset.variantId = selectedVariant.value;

        const bundleItems = Array.from(this.querySelectorAll('[data-bundle-item]'));
        if (bundleItems.some((item) => item.dataset.available === 'false')) {
          this.status.textContent = this.dataset.unavailableLabel || 'One or more items are unavailable';
          return;
        }

        const items = bundleItems.map((item) => ({
          id: Number(item.dataset.variantId),
          quantity: Math.max(1, Number(item.querySelector('[data-bundle-quantity]')?.value) || 1)
        })).filter((item) => item.id);
        if (!items.length) return;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        try {
          const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            body: JSON.stringify({items, sections: ['mini-cart'], sections_url: window.location.pathname})
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.description || 'Unable to add bundle');
          const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
          const cart = await cartResponse.json();
          cart.sections = result.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {bubbles: true, detail: {cart}}));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {cart, openMiniCart: window.themeVariables.settings.cartType === 'drawer'}}));
          this.status.textContent = this.dataset.successLabel || 'Added to cart';
        } catch (error) {
          const message = error instanceof Error && error.message ? error.message : 'Unable to add bundle';
          this.status.textContent = message;
          document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {bubbles: true, detail: {status: 'error', error: message}}));
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-product-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-proof-carousel')) {
    class UlikeProofCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-proof-tab], [data-proof-thumbnail]'));
        this.panels = Array.from(this.querySelectorAll('[data-proof-panel]'));
        this.usesThumbnailNavigation = this.hasAttribute('data-thumbnail-navigation') && this.querySelector('[data-proof-thumbnail]');
        if (this.tabs.length) {
          this.setAttribute('data-enhanced', '');
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activateTab(index));
            tab.addEventListener('keydown', (event) => this.handleTabKeydown(event, index));
          });
          this.activateTab(0);
        }
        this.querySelectorAll('[data-comparison]').forEach((comparison) => {
          const range = comparison.querySelector('[data-comparison-range]');
          if (!range) return;
          range.addEventListener('input', () => comparison.style.setProperty('--comparison-position', `${range.value}%`));
        });
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        if (!this.viewport || !this.previousButton || !this.nextButton) return;
        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.update(), { passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target.closest('[data-comparison-range]')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.viewport);
        }
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      activateTab(index, focus = false) {
        this.activeIndex = index;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex]?.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });
        this.tabs[index]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if (this.usesThumbnailNavigation) {
          const comparison = this.panels[index]?.querySelector('[data-comparison]');
          const range = comparison?.querySelector('[data-comparison-range]');
          if (comparison && range) {
            range.value = 50;
            comparison.style.setProperty('--comparison-position', '50%');
          }
          this.update();
        }
        if (focus) this.tabs[index]?.focus();
      }

      handleTabKeydown(event, index) {
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        this.activateTab(nextIndex, true);
      }

      move(direction) {
        if (this.usesThumbnailNavigation) {
          const nextIndex = Math.min(this.tabs.length - 1, Math.max(0, (this.activeIndex || 0) + direction));
          this.activateTab(nextIndex, true);
          return;
        }
        const card = this.viewport.querySelector('.ulike-product-proof__comparison');
        const list = this.viewport.querySelector('.ulike-product-proof__results-list');
        if (!card || !list) return;
        const gap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
      }

      update() {
        if (!this.previousButton || !this.nextButton) return;
        if (this.usesThumbnailNavigation) {
          this.previousButton.disabled = (this.activeIndex || 0) === 0;
          this.nextButton.disabled = (this.activeIndex || 0) === this.tabs.length - 1;
          return;
        }
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = maximum <= 2 || this.viewport.scrollLeft >= maximum - 2;
      }
    }

    customElements.define('ulike-proof-carousel', UlikeProofCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-product-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ulike-quiz]').forEach((quiz) => { const steps=[...quiz.querySelectorAll('[data-step]')], form=quiz.querySelector('.ulike-quiz__form'), error=quiz.querySelector('[data-error]'), back=quiz.querySelector('[data-back]'), next=quiz.querySelector('[data-next]'), result=quiz.querySelector('[data-result]'); let index=0; const show=()=>{steps.forEach((step,i)=>step.classList.toggle('is-hidden',i!==index));back.hidden=index===0;next.textContent=index===steps.length-1?'Get my results':'Next';}; next.addEventListener('click',()=>{if(!steps[index].querySelector('input:checked')){error.hidden=false;return;}error.hidden=true;if(index<steps.length-1){index+=1;show();return;}const answers=[...form.querySelectorAll('input:checked')].map((input)=>input.value).join(' ');const x=/Male|coarse|Not price-sensitive/.test(answers);const air10=/Not price-sensitive|Thick/.test(answers);const link=result.querySelector('[data-result-link]');result.querySelector('[data-result-copy]').textContent=air10?'Based on your answers, Ulike Air 10 is a strong match for your routine.':x?'Based on your answers, Ulike X is a strong match for your routine.':'Based on your answers, Ulike Air 4 is a strong match for your routine.';link.href=air10?'/products/sapphire-air-10-ipl-hair-removal?variant=44485783814385':x?'/products/ulike-x-ipl-hair-removal?variant=45509932056817':'/products/sapphire-air-4-ipl-laser-hair-removal?variant=47758665548017';form.classList.add('is-hidden');result.classList.remove('is-hidden');});back.addEventListener('click',()=>{if(index){index-=1;show();}});quiz.querySelector('[data-restart]').addEventListener('click',()=>{form.reset();index=0;result.classList.add('is-hidden');form.classList.remove('is-hidden');show();});show();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-product-results-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-product-results')) {
    customElements.define('ulike-product-results', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-results-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-results-panel]'));
        this.previousButton = this.querySelector('[data-results-previous]');
        this.nextButton = this.querySelector('[data-results-next]');
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.panels.forEach((panel) => {
          const viewport = panel.querySelector('[data-results-viewport]');
          viewport?.addEventListener('scroll', () => this.update(), { passive: true });
          viewport?.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          });
          if (viewport && 'ResizeObserver' in window) new ResizeObserver(() => this.update()).observe(viewport);
        });
        this.select(0);
      }

      get viewport() { return this.panels.find((panel) => !panel.hidden)?.querySelector('[data-results-viewport]'); }

      select(index, focus = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
        this.tabs[index]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if (focus) this.tabs[index]?.focus();
        requestAnimationFrame(() => this.update());
      }

      onTabKeydown(event, index) {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(next, true);
      }

      move(direction) {
        const viewport = this.viewport;
        const card = viewport?.querySelector('.ulike-product-results__card');
        const track = viewport?.querySelector('.ulike-product-results__track');
        if (!viewport || !card || !track) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }

      update() {
        const viewport = this.viewport;
        if (!viewport) return;
        const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        this.previousButton.disabled = viewport.scrollLeft <= 2;
        this.nextButton.disabled = maximum <= 2 || viewport.scrollLeft >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-showcase')) {
    customElements.define('product-showcase', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const swatch = event.target.closest('[data-showcase-swatch]');
          if (!swatch || !this.contains(swatch)) return;
          const card = swatch.closest('.ulike-product-showcase__card');
          const index = swatch.dataset.showcaseSwatch;
          card.querySelectorAll('[data-showcase-swatch]').forEach((button) => button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false'));
          card.querySelectorAll('[data-showcase-image]').forEach((media) => { media.hidden = media.dataset.showcaseImage !== index; });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-product-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-product-steps')) {
    customElements.define('ulike-product-steps', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-step-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-step-panel]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab.dataset.stepTab));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });
        this.select('1');
      }

      select(step) {
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.stepTab === step;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.stepPanel !== step; });
      }

      onTabKeydown(event, index) {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        const tab = this.tabs[next];
        this.select(tab.dataset.stepTab);
        tab.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-seo-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-seo-results')) customElements.define('ulike-seo-results', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.filters = [...this.querySelectorAll('[data-seo-filter]')];
      this.cards = [...this.querySelectorAll('[data-seo-result]')];
      this.more = this.querySelector('[data-seo-more]'); this.limit = 6;
      this.querySelector('[data-seo-filters]').hidden = false;
      for (const filter of this.filters) filter.addEventListener('change', () => { this.limit = 6; this.update(); }, { signal: this.controller.signal });
      this.more.addEventListener('click', () => { this.limit += 6; this.update(); }, { signal: this.controller.signal });
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    update() {
      let matched = 0;
      for (const card of this.cards) {
        const matches = this.filters.every(filter => !filter.value || card.dataset[filter.dataset.seoFilter] === filter.value);
        card.hidden = !matches || ++matched > this.limit;
        if (card.hidden) card.querySelector('video')?.pause();
      }
      this.more.hidden = matched <= this.limit;
      this.querySelector('[data-seo-empty]').hidden = matched !== 0;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-story-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('keydown', (event) => {
    const track = event.target.closest('[data-story-cards-track]');
    if (!track || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    if (track.scrollWidth <= track.clientWidth) return;
    event.preventDefault();
    const card = track.querySelector('.ulike-story-cards__card');
    if (!card) return;
    const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
    const direction = event.key === 'ArrowLeft' ? -1 : 1;
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-subscription-checkout"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.ulike-subscription-checkout';

    const isNumericId = (value) => /^\d+$/.test(value || '');

    const showError = (root) => {
      const content = root.querySelector('.ulike-subscription-checkout__content');
      const fallbackUrl = root.dataset.fallbackUrl;
      const heading = root.dataset.errorHeading;
      const message = root.dataset.errorMessage;
      const label = root.dataset.fallbackLabel;

      root.classList.add('ulike-subscription-checkout--error');
      content.setAttribute('role', 'alert');
      content.innerHTML = '';

      const title = document.createElement('p');
      title.textContent = heading;
      content.append(title);

      const detail = document.createElement('p');
      detail.textContent = message;
      content.append(detail);

      if (fallbackUrl) {
        const link = document.createElement('a');
        link.href = fallbackUrl;
        link.textContent = label;
        content.append(link);
      }
    };

    const beginCheckout = async (root) => {
      const subscriptionVariantId = root.dataset.subscriptionVariantId;
      const sellingPlanId = root.dataset.sellingPlanId;
      const mainVariantId = root.dataset.mainVariantId;
      const replaceCart = root.dataset.replaceCart === 'true';
      const storeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

      if (!isNumericId(subscriptionVariantId) || !isNumericId(sellingPlanId) || !isNumericId(mainVariantId)) {
        showError(root);
        return;
      }

      try {
        if (replaceCart) {
          const clearResponse = await fetch(`${storeRoot}cart/clear.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });

          if (!clearResponse.ok) {
            throw new Error('Cart clear failed');
          }
        }

        const addResponse = await fetch(`${storeRoot}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [
              { id: Number(subscriptionVariantId), quantity: 1, selling_plan: Number(sellingPlanId) },
              { id: Number(mainVariantId), quantity: 1 }
            ]
          })
        });

        if (!addResponse.ok) {
          throw new Error('Cart add failed');
        }

        window.location.replace(`${storeRoot}checkout`);
      } catch (error) {
        showError(root);
      }
    };

    document.querySelectorAll(selector).forEach((root) => {
      if (root.dataset.initialized === 'true') {
        return;
      }

      root.dataset.initialized = 'true';
      beginCheckout(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-technology-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ulike-technology-showcase')) {
    customElements.define('ulike-technology-showcase', class extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('[data-scroller]');
        if (!this.scroller) return;
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.scroller.addEventListener('scroll', () => this.updateControls(), { passive: true });
        new ResizeObserver(() => this.updateControls()).observe(this.scroller);
        this.updateControls();
      }

      move(direction) {
        const card = this.scroller.querySelector('.ulike-technology-showcase__video-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.scroller).columnGap) || 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scroller.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      updateControls() {
        const maximum = Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth);
        const position = Math.abs(this.scroller.scrollLeft);
        if (this.previousButton) this.previousButton.disabled = position <= 2;
        if (this.nextButton) this.nextButton.disabled = position >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ulike-video-cards"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-video-dialog-open]').forEach((button)=>button.addEventListener('click',()=>document.getElementById(button.dataset.videoDialogOpen).showModal()));document.querySelectorAll('[data-video-dialog-close]').forEach((button)=>button.addEventListener('click',()=>button.closest('dialog').close()));
  } catch(e) { console.error(e); }
})();
})();
